<script setup>
</script>
<template>
  <main
    class="page-container mx-auto px-4 pb-4 md:px-0 mt-4 max-w-[1302px] md:mt-6"
  >
    <div class="flex gap-10">
      <div class="w-full flex-1 md:max-w-[942px]">
        <div class="flex flex-col pb-6">
          <span class="text-3xl font-semibold">₹112.42</span
          ><span class="text-base font-semibold text-[#CE3A3A]"
            >-₹7.94 (-6.6%)
            <span class="text-sm text-[#6A6A6A]">Today</span></span
          ><span
            class="text-left text-[13px] font-medium leading-5 text-[#6A6A6A]"
            >Last updated on 28 Feb, 2025 | 15:59 IST</span
          >
        </div>
        <h2
          class="pt-8 md:pt-0 text-xl font-medium md:font-semibold non-italic text-[#101010]"
        >
          Indian Railway Finance Corp Share Price Chart
        </h2>
        <div class="relative">
          <div>
            <div
              class="tv-lightweight-charts"
              style="
                overflow: hidden;
                direction: ltr;
                width: 942px;
                height: 300px;
                user-select: none;
                -webkit-tap-highlight-color: transparent;
              "
            >
              <table cellspacing="0" style="height: 300px; width: 942px">
                <tr>
                  <td style="padding: 0px"></td>
                  <td
                    style="
                      padding: 0px;
                      position: relative;
                      width: 942px;
                      height: 300px;
                    "
                  >
                    <div
                      style="
                        width: 100%;
                        height: 100%;
                        position: relative;
                        overflow: hidden;
                      "
                    >
                      <canvas
                        style="
                          width: 942px;
                          height: 300px;
                          position: absolute;
                          z-index: 1;
                          left: 0px;
                          top: 0px;
                        "
                        width="942"
                        height="300"
                      ></canvas
                      ><canvas
                        style="
                          width: 942px;
                          height: 300px;
                          position: absolute;
                          z-index: 2;
                          left: 0px;
                          top: 0px;
                        "
                        width="942"
                        height="300"
                      ></canvas>
                    </div>
                  </td>
                  <td style="padding: 0px"></td>
                </tr>
                <tr style="display: none">
                  <td style="padding: 0px"></td>
                  <td style="height: 25px; padding: 0px">
                    <div
                      style="
                        width: 100%;
                        height: 100%;
                        position: relative;
                        overflow: hidden;
                      "
                    >
                      <canvas
                        style="
                          width: 16px;
                          height: 16px;
                          position: absolute;
                          z-index: 1;
                          left: 0px;
                          top: 0px;
                        "
                      ></canvas
                      ><canvas
                        style="
                          width: 16px;
                          height: 16px;
                          position: absolute;
                          z-index: 2;
                          left: 0px;
                          top: 0px;
                        "
                      ></canvas>
                    </div>
                  </td>
                  <td style="padding: 0px"></td>
                </tr>
              </table>
            </div>
          </div>
          <div
            class="trading-view-chart-tooltip"
            style="display: none; left: 734px; top: 0px"
          >
            <div class="trading-view-chart-tooltip-inner-text">
              <span> ₹112.30</span>
              <span class="text-[#CE3A3A]"> -₹0.07 (-0.06%) </span>
            </div>
            <div>28 February, 5:45 PM</div>
          </div>
          <a target="_blank" href="https://tv.upstox.com/charts/NSE_EQ|2029/"
            ><img
              alt="TradingView Icon"
              loading="lazy"
              width="36"
              height="36"
              decoding="async"
              data-nimg="1"
              class="absolute left-4 top-60 z-[6] cursor-pointer"
              src="/next-scrip-assets/chart-library.svg"
              style="color: transparent"
          /></a>
        </div>
        <div class="relative flex flex-row justify-between pt-5">
          <span class="text-sm">₹111.70</span
          ><span class="text-sm">₹119.43</span>
        </div>
        <div class="flex flex-row items-center justify-center gap-1 pb-2">
          <span class="text-sm text-gray-500">L</span>
          <div
            class="relative h-2 w-full rounded-[4px] bg-gradient-to-r from-[#7DCECD] to-[#AFA9DF]"
          >
            <img
              alt="Show Current Price"
              loading="lazy"
              width="18"
              height="12"
              decoding="async"
              data-nimg="1"
              class="absolute top-[-2px]"
              src="/next-scrip-assets/price-point-arrow.svg"
              style="color: transparent; left: 9.31436%"
            />
          </div>
          <span class="text-sm text-gray-500">H</span>
        </div>
        <div
          class="mt-2 flex w-full items-center justify-center overflow-x-auto pb-2 sm:justify-between sm:gap-0"
        >
          <div class="flex flex-row gap-0 sm:gap-1">
            <button
              class="text-sm font-semibold disabled:cursor-not-allowed hover:bg-primary-dark rounded-0 h-[40px] w-[40px] cursor-pointer rounded-full p-0 active:bg-[#5A2989] active:text-white disabled:bg-black/10 sm:h-9 sm:w-9 bg-[#5A2989] text-white"
            >
              1D</button
            ><button
              class="text-sm font-semibold disabled:cursor-not-allowed hover:bg-primary-dark rounded-0 h-[40px] w-[40px] cursor-pointer rounded-full bg-transparent p-0 text-gray-accent3 active:bg-[#5A2989] active:text-white disabled:bg-black/10 sm:h-9 sm:w-9 sm:hover:bg-[#F2ECFD] sm:hover:text-[#6A6A6A]"
            >
              1W</button
            ><button
              class="text-sm font-semibold disabled:cursor-not-allowed hover:bg-primary-dark rounded-0 h-[40px] w-[40px] cursor-pointer rounded-full bg-transparent p-0 text-gray-accent3 active:bg-[#5A2989] active:text-white disabled:bg-black/10 sm:h-9 sm:w-9 sm:hover:bg-[#F2ECFD] sm:hover:text-[#6A6A6A]"
            >
              1M</button
            ><button
              class="text-sm font-semibold disabled:cursor-not-allowed hover:bg-primary-dark rounded-0 h-[40px] w-[40px] cursor-pointer rounded-full bg-transparent p-0 text-gray-accent3 active:bg-[#5A2989] active:text-white disabled:bg-black/10 sm:h-9 sm:w-9 sm:hover:bg-[#F2ECFD] sm:hover:text-[#6A6A6A]"
            >
              1Y</button
            ><button
              class="text-sm font-semibold disabled:cursor-not-allowed hover:bg-primary-dark rounded-0 h-[40px] w-[40px] cursor-pointer rounded-full bg-transparent p-0 text-gray-accent3 active:bg-[#5A2989] active:text-white disabled:bg-black/10 sm:h-9 sm:w-9 sm:hover:bg-[#F2ECFD] sm:hover:text-[#6A6A6A]"
            >
              3Y</button
            ><button
              class="text-sm font-semibold disabled:cursor-not-allowed hover:bg-primary-dark rounded-0 h-[40px] w-[40px] cursor-pointer rounded-full bg-transparent p-0 text-gray-accent3 active:bg-[#5A2989] active:text-white disabled:bg-black/10 sm:h-9 sm:w-9 sm:hover:bg-[#F2ECFD] sm:hover:text-[#6A6A6A]"
            >
              5Y</button
            ><button
              class="text-sm font-semibold disabled:cursor-not-allowed hover:bg-primary-dark rounded-0 h-[40px] w-[40px] cursor-pointer rounded-full bg-transparent p-0 text-gray-accent3 active:bg-[#5A2989] active:text-white disabled:bg-black/10 sm:h-9 sm:w-9 sm:hover:bg-[#F2ECFD] sm:hover:text-[#6A6A6A]"
            >
              All
            </button>
          </div>
          <div class="flex flex-row items-center justify-center gap-2">
            <div class="flex items-center gap-1 rounded-3xl bg-[#f1f1f1] p-1">
              <button
                class="cursor-pointer rounded-3xl px-4 py-1.5 text-[13px] font-semibold leading-5 bg-primary-base text-background-base"
              >
                NSE</button
              ><button
                class="cursor-pointer rounded-3xl px-4 py-1.5 text-[13px] font-semibold leading-5 text-primary-text"
              >
                BSE
              </button>
            </div>
            <div class="flex p-2">
              <div class="flex h-5 w-[1px] bg-[#E1E1E1]"></div>
            </div>
            <div class="flex items-center gap-1 rounded-3xl bg-[#f1f1f1] p-1">
              <button
                class="cursor-pointer rounded-3xl px-4 py-1.5 text-[13px] font-semibold leading-5 bg-primary-base text-background-base"
              >
                <img
                  alt="Toggle Button Icon"
                  loading="lazy"
                  width="24"
                  height="24"
                  decoding="async"
                  data-nimg="1"
                  class="rounded-full"
                  src="/next-scrip-assets/line-chart-white.svg"
                  style="color: transparent"
                /></button
              ><button
                class="cursor-pointer rounded-3xl px-4 py-1.5 text-[13px] font-semibold leading-5 text-primary-text"
              >
                <img
                  alt="Toggle Button Icon"
                  loading="lazy"
                  width="24"
                  height="24"
                  decoding="async"
                  data-nimg="1"
                  class="rounded-full"
                  src="/next-scrip-assets/candle-chart-black.svg"
                  style="color: transparent"
                />
              </button>
            </div>
          </div>
        </div>
        <div class="py-6 pb-0" id="Company overview" data-section="true">
          <div class="flex w-full items-center justify-between">
            <div
              class="flex gap-1 text-xl font-semibold leading-7 text-lighter-black mb-0"
            >
              <h2>About Indian Railway Finance Corp</h2>
            </div>
          </div>
          <div class="py-6" id="About" data-section="true">
            <div
              class="flex w-full items-center justify-between cursor-pointer"
            >
              <div
                class="flex gap-1 text-lighter-black text-base font-semibold mb-2"
              >
                <h2>Indian Railway Finance Corp Financials</h2>
              </div>
              <img
                alt="arrow"
                loading="lazy"
                width="24"
                height="24"
                decoding="async"
                data-nimg="1"
                class="cursor-pointer text-base font-semibold mb-2"
                style="color: transparent"
                src="/next-scrip-assets/up-arrow.svg"
              />
            </div>
            <div itemscope="" itemtype="https://schema.org/Table">
              <table class="w-full">
                <tbody
                  class="flex flex-col rounded-xl md:flex-row md:gap-8 md:rounded-none"
                >
                  <tr
                    class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 rounded-t-xl md:rounded-none border-b border-gray-accent2 md:border-b-0 md:border-r"
                  >
                    <td
                      class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                    >
                      <div
                        class="text-sm font-medium leading-5 text-gray-accent3"
                      >
                        Market cap
                      </div>
                      <div
                        class="text-sm font-medium leading-5 text-light-black"
                      >
                        <div class="flex flex-row gap-1">
                          <img
                            alt="Market Cap Switch"
                            loading="lazy"
                            width="16"
                            height="16"
                            decoding="async"
                            data-nimg="1"
                            class="cursor-pointer"
                            style="color: transparent"
                            src="/next-scrip-assets/revenue-switch.svg"
                          />₹1,46,916 Crs
                        </div>
                      </div>
                    </td>
                    <td
                      class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                    >
                      <div
                        class="text-sm font-medium leading-5 text-gray-accent3"
                      >
                        Open
                      </div>
                      <div
                        class="text-sm font-medium leading-5 text-light-black"
                      >
                        ₹118.99
                      </div>
                    </td>
                    <td
                      class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                    >
                      <div
                        class="text-sm font-medium leading-5 text-gray-accent3"
                      >
                        Close
                      </div>
                      <div
                        class="text-sm font-medium leading-5 text-light-black"
                      >
                        ₹120.36
                      </div>
                    </td>
                  </tr>
                  <tr
                    class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 border-b border-gray-accent2 md:border-b-0 md:border-r"
                  >
                    <td
                      class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                    >
                      <div
                        class="text-sm font-medium leading-5 text-gray-accent3"
                      >
                        Circuit range
                      </div>
                      <div
                        class="text-sm font-medium leading-5 text-light-black"
                      >
                        ₹123.66 - ₹101.17
                      </div>
                    </td>
                    <td
                      class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                    >
                      <div
                        class="text-sm font-medium leading-5 text-gray-accent3"
                      >
                        Day range
                      </div>
                      <div
                        class="text-sm font-medium leading-5 text-light-black"
                      >
                        ₹111.70 - ₹119.43
                      </div>
                    </td>
                    <td
                      class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                    >
                      <div
                        class="text-sm font-medium leading-5 text-gray-accent3"
                      >
                        Year range
                      </div>
                      <div
                        class="text-sm font-medium leading-5 text-light-black"
                      >
                        ₹111.70 - ₹229.00
                      </div>
                    </td>
                  </tr>
                  <tr
                    class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 rounded-b-xl md:rounded-none"
                  >
                    <td
                      class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                    >
                      <div
                        class="text-sm font-medium leading-5 text-gray-accent3"
                      >
                        Volume
                      </div>
                      <div
                        class="text-sm font-medium leading-5 text-light-black"
                      >
                        2,89,27,630
                      </div>
                    </td>
                    <td
                      class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                    >
                      <div
                        class="text-sm font-medium leading-5 text-gray-accent3"
                      >
                        Avg. traded
                      </div>
                      <div
                        class="text-sm font-medium leading-5 text-light-black"
                      >
                        ₹114.87
                      </div>
                    </td>
                    <td
                      class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                    >
                      <div
                        class="text-sm font-medium leading-5 text-gray-accent3"
                      >
                        Revenue (12m)
                      </div>
                      <div
                        class="text-sm font-medium leading-5 text-light-black"
                      >
                        ₹26,886 Crs
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="rounded-2xl bg-gray-light p-6 pb-4 mt-4">
              <div
                class="flex h-[207px] flex-col gap-4 overflow-y-auto text-sm font-medium leading-5 text-[#444] md:h-[228px]"
              >
                <span class="text-sm font-semibold"
                  >Indian Railway Finance Corp</span
                ><span
                  ><div class="markdown">
                    <p>
                      Set up in December 1986, the Indian Railway Finance
                      Corporation (IRFC) is a public sector undertaking (PSU)
                      with the government owning a majority stake.
                    </p>
                    <p>
                      IRFC, the financing arm of the Indian Railways, arranges
                      funds from domestic and overseas markets to meet
                      requirements, beyond budgetary allocations. In more than
                      three decades of its existence, IRFC has played a key role
                      in supporting the expansion and modernisation of the
                      Indian Railways. The primary operations of the company
                      include financing the acquisition of rolling stock assets,
                      leasing of railway infrastructure assets and national
                      projects. IRFC also provides lending to various entities
                      of the Railway Ministry.
                    </p>
                    <p>
                      The company borrows funds from the financial markets to
                      fund the acquisition or creation of assets, which are then
                      leased out to the Indian Railways. The cumulative funding
                      by IRFC to the railway sector crossed ₹5.04 lakh crore in
                      FY2022. It has funded acquisition of 13764 locomotives,
                      76735 passenger coaches, and 265815 wagons, which
                      constitute around 75% of the total rolling stock fleet of
                      Indian Railways.
                    </p>
                    <p>
                      The Railway Ministry PSU has a market capitalisation of
                      ₹100,078 crore as on December 9, 2023. The government held
                      an 86.36% stake in the company as on September 30, 2023.
                    </p>
                    <p>
                      IRFC was listed on the bourses after launch on its IPO in
                      January 2021. IRFC share price has surged more than 228%
                      since its listing on the bourses, as of December 11, 2023.
                    </p>
                    <h2>Business segments of IRFC</h2>
                    <h3>Leasing Operations</h3>
                    <p>
                      This remains the primary business segment of IRFC,
                      contributing a significant portion of its revenue. IRFC
                      uses a leasing approach to fund Indian Railways' rolling
                      stock and project assets, including locomotives, coaches,
                      wagons, trucks, flats, electric multiple units (EMUs),
                      containers, cranes, trolleys, and other rolling stock
                      components.
                    </p>
                    <p>
                      The company’s lease term is essentially 30 years – a
                      primary component of 15 years and a secondary of 15 years.
                    </p>
                    <p>
                      During the primary lease period, the principal component
                      and interest are recovered as part of the lease. During
                      the secondary lease period of 15 years, IRFC receives a
                      nominal rent.
                    </p>
                    <p>
                      After secondary lease period assets are normally
                      transferred to the Railway Ministry at a nominal amount.
                      It has a cost-plus leasing agreement with the Ministry of
                      Railways, which ensures consistent growth in its income
                      and profitability. The Ministry pays half-yearly lease
                      rentals, which include both principal repayment and
                      interest.
                    </p>
                    <p>
                      The company provides funds to Indian Railways’ entities
                      like Rail Vikas Nigam Ltd (RVNL), Rail Land Development
                      Authority and Railtel Corporation of India.
                    </p>
                    <h3>Borrowing operations</h3>
                    <p>
                      IRFC raises funds through various sources at very
                      competitive rates. The source of funds include taxable and
                      tax-free bonds issuances, term loans from banks and
                      financial institutions, commercial papers, external
                      commercial borrowings and asset securitisation. Due to its
                      strong credit ratings, it gets funds at significantly low
                      cost. As of March 31, 2023, the company borrowed funds of
                      ₹1,84,531 crore, which included ₹1,59,041 crore in term
                      loans and ₹71,738 crore in external borrowing.
                    </p>
                    <h2>Financial highlights</h2>
                    <p>
                      • In FY23, IRCF’s total income surged 17.7% to ₹23,891.27
                      crore from ₹20,298.27 crore in FY22. • The total
                      expenditure was at ₹49,450.6 crore, up 11% from ₹44,399.87
                      crore in the year before. • The profit before tax
                      increased 4% to ₹6,337.01 crore from ₹6,090.15 crore. •
                      There was also a 4% jump in IRFC’s net profit at ₹6,337.01
                      crore as against ₹6089.84 crore in FY 2021-22. • Earnings
                      per share increased to ₹4.85 in FY23 from ₹4.66 in the
                      previous financial year.
                    </p>
                  </div></span
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
        ></div>
        <div class="py-6" id="Key indicators" data-section="true">
          <div class="flex w-full items-center justify-between cursor-pointer">
            <div
              class="flex gap-1 text-base font-semibold leading-6 text-lighter-black mb-2"
            >
              <h2>Indian Railway Finance Corp Key indicators</h2>
            </div>
            <img
              alt="arrow"
              loading="lazy"
              width="24"
              height="24"
              decoding="async"
              data-nimg="1"
              class="cursor-pointer text-base font-semibold leading-6 text-lighter-black mb-2"
              style="color: transparent"
              src="/next-scrip-assets/up-arrow.svg"
            />
          </div>
          <div itemscope="" itemtype="https://schema.org/Table">
            <table class="w-full">
              <tbody
                class="flex flex-col rounded-xl md:flex-row md:gap-8 md:rounded-none"
              >
                <tr
                  class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 rounded-t-xl md:rounded-none border-b border-gray-accent2 md:border-b-0 md:border-r"
                >
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      52 week high
                    </div>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      ₹229.00
                    </div>
                  </td>
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      52 week low
                    </div>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      ₹111.70
                    </div>
                  </td>
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      P/E ratio
                    </div>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      22.5
                    </div>
                  </td>
                </tr>
                <tr
                  class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 border-b border-gray-accent2 md:border-b-0 md:border-r"
                >
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      P/B ratio
                    </div>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      3.14
                    </div>
                  </td>
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      ROE
                    </div>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      13.66%
                    </div>
                  </td>
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      ROCE
                    </div>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      5.73%
                    </div>
                  </td>
                </tr>
                <tr
                  class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 rounded-b-xl md:rounded-none"
                >
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      Dividend yield
                    </div>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      1.2%
                    </div>
                  </td>
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      Debt/Equity ratio
                    </div>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      8.38
                    </div>
                  </td>
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      EPS
                    </div>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      4.91
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              class="mt-4 w-fit cursor-pointer text-sm font-semibold leading-5 text-primary-base md:mt-2"
            >
              Learn more
            </p>
          </div>
        </div>
        <div
          class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
        ></div>
        <div class="py-6" id="Featured in" data-section="true">
          <div class="flex w-full items-center justify-between cursor-pointer">
            <div
              class="flex gap-1 text-base font-semibold leading-6 text-lighter-black mb-2"
            >
              <h2>Sector</h2>
            </div>
            <img
              alt="arrow"
              loading="lazy"
              width="24"
              height="24"
              decoding="async"
              data-nimg="1"
              class="cursor-pointer text-base font-semibold leading-6 text-lighter-black mb-2"
              style="color: transparent"
              src="/next-scrip-assets/up-arrow.svg"
            />
          </div>
          <div class="mt-4 flex flex-wrap">
            <a
              target="_blank"
              href="/stocks-market/company-list/finance-sector/"
              ><div
                class="group flex min-w-[130px] cursor-pointer flex-row items-center justify-center gap-3 rounded-[100px] border border-[#F2F2F2] bg-[#F5F5F5] py-2 pl-2 pr-4 hover:border-primary-base hover:bg-[#F2ECFD]"
              >
                <img
                  alt="Featured In Icon"
                  loading="lazy"
                  width="32"
                  height="32"
                  decoding="async"
                  data-nimg="1"
                  class="h-8 w-8 rounded-full"
                  src="/next-scrip-assets/MoneyMouthFace.svg"
                  style="color: transparent"
                /><span
                  class="text-sm font-normal text-[#101010] group-hover:text-[#41246E]"
                  >Finance</span
                >
              </div></a
            >
          </div>
        </div>
        <div
          class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
        ></div>
        <div
          class="py-6 flex flex-col md:flex-row"
          id="Investment Checklist Container"
          data-section="true"
        >
          <div
            class="flex w-full flex-col gap-4 border-b border-gray-accent2 md:border-b-0 md:pr-10 md:border-r"
          >
            <div
              class="py-6 pb-6 pt-0 sm:py-0"
              id="Investment checklist"
              data-section="true"
            >
              <div
                class="flex w-full items-center justify-between cursor-pointer"
              >
                <div
                  class="flex gap-1 text-base font-semibold leading-6 text-lighter-black mb-4"
                >
                  <div>Investment checklist: (1/6)</div>
                </div>
                <img
                  alt="arrow"
                  loading="lazy"
                  width="24"
                  height="24"
                  decoding="async"
                  data-nimg="1"
                  class="cursor-pointer text-base font-semibold leading-6 text-lighter-black mb-4"
                  style="color: transparent"
                  src="/next-scrip-assets/up-arrow.svg"
                />
              </div>
              <div class="mb-4 grid w-full grid-cols-3 gap-2">
                <div
                  class="flex w-fit min-w-[108px] cursor-pointer flex-col items-center justify-center gap-2 rounded-lg bg-gray-light p-2 sm:min-w-[140px]"
                >
                  <img
                    alt="check status"
                    loading="lazy"
                    width="24"
                    height="24"
                    decoding="async"
                    data-nimg="1"
                    class="rounded-full"
                    src="/next-scrip-assets/absent.svg"
                    style="color: transparent"
                  />
                  <p
                    class="max-w-[60px] px-2 text-center text-[13px] font-medium leading-5 text-primary-base md:w-[120px] md:px-0"
                  >
                    Equity returns
                  </p>
                </div>
                <div
                  class="flex w-fit min-w-[108px] cursor-pointer flex-col items-center justify-center gap-2 rounded-lg bg-gray-light p-2 sm:min-w-[140px]"
                >
                  <img
                    alt="check status"
                    loading="lazy"
                    width="24"
                    height="24"
                    decoding="async"
                    data-nimg="1"
                    class="rounded-full"
                    src="/next-scrip-assets/absent.svg"
                    style="color: transparent"
                  />
                  <p
                    class="max-w-[60px] px-2 text-center text-[13px] font-medium leading-5 text-primary-base md:w-[120px] md:px-0"
                  >
                    Dividend returns
                  </p>
                </div>
                <div
                  class="flex w-fit min-w-[108px] cursor-pointer flex-col items-center justify-center gap-2 rounded-lg bg-gray-light p-2 sm:min-w-[140px]"
                >
                  <img
                    alt="check status"
                    loading="lazy"
                    width="24"
                    height="24"
                    decoding="async"
                    data-nimg="1"
                    class="rounded-full"
                    src="/next-scrip-assets/green-check.svg"
                    style="color: transparent"
                  />
                  <p
                    class="max-w-[60px] px-2 text-center text-[13px] font-medium leading-5 text-primary-base md:w-[120px] md:px-0"
                  >
                    Safety factor
                  </p>
                </div>
                <div
                  class="flex w-fit min-w-[108px] cursor-pointer flex-col items-center justify-center gap-2 rounded-lg bg-gray-light p-2 sm:min-w-[140px]"
                >
                  <img
                    alt="check status"
                    loading="lazy"
                    width="24"
                    height="24"
                    decoding="async"
                    data-nimg="1"
                    class="rounded-full"
                    src="/next-scrip-assets/unknown.svg"
                    style="color: transparent"
                  />
                  <p
                    class="max-w-[60px] px-2 text-center text-[13px] font-medium leading-5 text-primary-base md:w-[120px] md:px-0"
                  >
                    Growth factor
                  </p>
                </div>
                <div
                  class="flex w-fit min-w-[108px] cursor-pointer flex-col items-center justify-center gap-2 rounded-lg bg-gray-light p-2 sm:min-w-[140px]"
                >
                  <img
                    alt="check status"
                    loading="lazy"
                    width="24"
                    height="24"
                    decoding="async"
                    data-nimg="1"
                    class="rounded-full"
                    src="/next-scrip-assets/absent.svg"
                    style="color: transparent"
                  />
                  <p
                    class="max-w-[60px] px-2 text-center text-[13px] font-medium leading-5 text-primary-base md:w-[120px] md:px-0"
                  >
                    Debt vs Equity
                  </p>
                </div>
                <div
                  class="flex w-fit min-w-[108px] cursor-pointer flex-col items-center justify-center gap-2 rounded-lg bg-gray-light p-2 sm:min-w-[140px]"
                >
                  <img
                    alt="check status"
                    loading="lazy"
                    width="24"
                    height="24"
                    decoding="async"
                    data-nimg="1"
                    class="rounded-full"
                    src="/next-scrip-assets/unknown.svg"
                    style="color: transparent"
                  />
                  <p
                    class="max-w-[60px] px-2 text-center text-[13px] font-medium leading-5 text-primary-base md:w-[120px] md:px-0"
                  >
                    Profit factor
                  </p>
                </div>
              </div>
              <p
                class="w-full text-[13px] font-medium leading-5 text-gray-accent3 md:w-[422px]"
              >
                The investment checklist helps you understand a company's
                financial health at a glance and identify quality investment
                opportunities easily
              </p>
            </div>
          </div>
          <div
            class="py-6 flex w-full flex-col pb-0 pt-6 sm:py-0 md:pl-10"
            id="Analyst ratings"
            data-section="true"
          >
            <div
              class="flex w-full items-center justify-between cursor-pointer"
            >
              <div
                class="flex gap-1 text-base font-semibold leading-6 text-lighter-black mb-4"
              >
                <h2>
                  <div class="flex gap-2 text-base font-semibold leading-6">
                    <p>Analyst ratings:</p>
                    <span class="text-danger"> Sell</span>
                  </div>
                </h2>
              </div>
              <img
                alt="arrow"
                loading="lazy"
                width="24"
                height="24"
                decoding="async"
                data-nimg="1"
                class="cursor-pointer text-base font-semibold leading-6 text-lighter-black mb-4"
                style="color: transparent"
                src="/next-scrip-assets/up-arrow.svg"
              />
            </div>
            <div class="flex h-12 mt-0">
              <div
                class="rounded-l-lg bg-bar-chart-green"
                style="width: 0%"
              ></div>
              <div class="bg-dark-yellow rounded-l-lg" style="width: 0%"></div>
              <div
                class="rounded-r-lg bg-danger rounded-l-lg"
                style="width: 100%"
              ></div>
            </div>
            <div
              class="mt-6 flex items-center justify-between text-gray-accent3"
            >
              <div>
                <p class="text-sm font-medium leading-5 text-bar-chart-green">
                  Buy
                </p>
                <p class="text-sm font-bold leading-5">0%</p>
              </div>
              <div>
                <p class="text-sm font-medium leading-5 text-dark-yellow">
                  Hold
                </p>
                <p class="text-sm font-bold leading-5">0%</p>
              </div>
              <div>
                <p class="text-sm font-medium leading-5 text-danger">Sell</p>
                <p class="text-sm font-bold leading-5">100%</p>
              </div>
            </div>
            <p class="mt-6 text-[13px] font-medium leading-5 text-gray-accent3">
              This analysis is based on the reviews of 1 experts in the last 7
              days
            </p>
          </div>
        </div>
        <div
          class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
        ></div>
        <div class="py-6 pb-0" id="Fundamentals" data-section="true">
          <div class="flex w-full items-center justify-between">
            <div
              class="flex gap-1 text-xl font-semibold leading-7 text-lighter-black mb-0"
            >
              <h2>Indian Railway Finance Corp Fundamentals</h2>
            </div>
          </div>
        </div>
        <div class="py-6" id="Financial ratios" data-section="true">
          <div class="flex w-full items-center justify-between cursor-pointer">
            <div
              class="gap-1 text-lighter-black text-base flex flex-row font-semibold leading-6 mb-2"
            >
              <h2>Indian Railway Finance Corp Financial Ratios</h2>
            </div>
            <img
              alt="arrow"
              loading="lazy"
              width="24"
              height="24"
              decoding="async"
              data-nimg="1"
              class="cursor-pointer text-base flex flex-row font-semibold leading-6 mb-2"
              style="color: transparent"
              src="/next-scrip-assets/up-arrow.svg"
            />
          </div>
          <ul
            class="no-scrollbar mx-[-16px] mt-4 flex cursor-pointer gap-6 overflow-auto border-b-2 border-gray-accent2 text-center text-gray-accent3 sm:mx-0 mb-4 text-base font-medium leading-6"
          >
            <li class="">
              <div
                class="inline-block py-2 border-b-2 border-primary-base font-semibold text-primary-base"
              >
                <h3
                  class="flex gap-1 whitespace-nowrap px-1 py-2 md:hover:rounded md:hover:bg-primary-light md:hover:text-primary-base"
                >
                  Profitability
                </h3>
              </div>
            </li>
            <li class="">
              <div class="inline-block py-2">
                <h3
                  class="flex gap-1 whitespace-nowrap px-1 py-2 md:hover:rounded md:hover:bg-primary-light md:hover:text-primary-base"
                >
                  Operational
                </h3>
              </div>
            </li>
            <li class="">
              <div class="inline-block py-2">
                <h3
                  class="flex gap-1 whitespace-nowrap px-1 py-2 md:hover:rounded md:hover:bg-primary-light md:hover:text-primary-base"
                >
                  Valuation
                </h3>
              </div>
            </li>
          </ul>
          <div itemscope="" itemtype="https://schema.org/Table">
            <table class="w-full">
              <tbody
                class="flex flex-col rounded-xl md:flex-row md:gap-8 md:rounded-none"
              >
                <tr
                  class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 rounded-t-xl md:rounded-none border-b border-gray-accent2 md:border-b-0 md:border-r"
                >
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                  >
                    <h3 class="text-sm font-medium leading-5 text-gray-accent3">
                      Operating profit margin
                    </h3>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      99.54%
                    </div>
                  </td>
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                  >
                    <h3 class="text-sm font-medium leading-5 text-gray-accent3">
                      Net profit margin
                    </h3>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      24.07%
                    </div>
                  </td>
                </tr>
                <tr
                  class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 border-b border-gray-accent2 md:border-b-0 md:border-r"
                >
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                  >
                    <h3 class="text-sm font-medium leading-5 text-gray-accent3">
                      ROE
                    </h3>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      13.66%
                    </div>
                  </td>
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                  >
                    <h3 class="text-sm font-medium leading-5 text-gray-accent3">
                      ROA
                    </h3>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      1.31%
                    </div>
                  </td>
                </tr>
                <tr
                  class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 rounded-b-xl md:rounded-none"
                >
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                  >
                    <h3 class="text-sm font-medium leading-5 text-gray-accent3">
                      ROCE
                    </h3>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      5.73%
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="hidden">
              <tbody
                class="flex flex-col rounded-xl md:flex-row md:gap-8 md:rounded-none"
              >
                <tr
                  class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 rounded-t-xl md:rounded-none border-b border-gray-accent2 md:border-b-0 md:border-r"
                >
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                  >
                    <h3 class="text-sm font-medium leading-5 text-gray-accent3">
                      Quick ratio
                    </h3>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      20.1
                    </div>
                  </td>
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                  >
                    <h3 class="text-sm font-medium leading-5 text-gray-accent3">
                      Current ratio
                    </h3>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      20.1
                    </div>
                  </td>
                </tr>
                <tr
                  class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 border-b border-gray-accent2 md:border-b-0 md:border-r"
                >
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                  >
                    <h3 class="text-sm font-medium leading-5 text-gray-accent3">
                      Interest coverage
                    </h3>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      1.32
                    </div>
                  </td>
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                  >
                    <h3 class="text-sm font-medium leading-5 text-gray-accent3">
                      Asset turnover
                    </h3>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      0.05
                    </div>
                  </td>
                </tr>
                <tr
                  class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 rounded-b-xl md:rounded-none"
                >
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                  >
                    <h3 class="text-sm font-medium leading-5 text-gray-accent3">
                      Debt to Equity
                    </h3>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      8.38
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="hidden">
              <tbody
                class="flex flex-col rounded-xl md:flex-row md:gap-8 md:rounded-none"
              >
                <tr
                  class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 rounded-t-xl md:rounded-none border-b border-gray-accent2 md:border-b-0 md:border-r"
                >
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                  >
                    <h3 class="text-sm font-medium leading-5 text-gray-accent3">
                      P/E ratio
                    </h3>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      22.5
                    </div>
                  </td>
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                  >
                    <h3 class="text-sm font-medium leading-5 text-gray-accent3">
                      P/B ratio
                    </h3>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      3.14
                    </div>
                  </td>
                </tr>
                <tr
                  class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 border-b border-gray-accent2 md:border-b-0 md:border-r"
                >
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                  >
                    <h3 class="text-sm font-medium leading-5 text-gray-accent3">
                      EV / EBITDA
                    </h3>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      22.53
                    </div>
                  </td>
                </tr>
                <tr
                  class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 rounded-b-xl md:rounded-none"
                >
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                  >
                    <h3 class="text-sm font-medium leading-5 text-gray-accent3">
                      Dividend yield
                    </h3>
                    <div class="text-sm font-medium leading-5 text-light-black">
                      1.2%
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p
            class="w-fit cursor-pointer pt-4 text-sm font-bold leading-[130%] tracking-[-0.18px] text-primary-base"
          >
            Learn more
          </p>
        </div>
        <div
          class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
        ></div>
        <div class="py-6" id="Shareholder returns" data-section="true">
          <div class="flex w-full items-center justify-between cursor-pointer">
            <div
              class="mb-4 flex gap-1 text-lighter-black text-base font-semibold leading-6"
            >
              <h2>Indian Railway Finance Corp Shareholder returns</h2>
            </div>
            <img
              alt="arrow"
              loading="lazy"
              width="24"
              height="24"
              decoding="async"
              data-nimg="1"
              class="mb-4 cursor-pointer text-base font-semibold leading-6"
              style="color: transparent"
              src="/next-scrip-assets/up-arrow.svg"
            />
          </div>
          <div itemscope="" itemtype="https://schema.org/Table">
            <table class="w-full">
              <tbody
                class="flex flex-col rounded-xl md:flex-row md:gap-8 md:rounded-none"
              >
                <tr
                  class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 rounded-t-xl md:rounded-none border-b border-gray-accent2 md:border-b-0 md:border-r"
                >
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      1 day
                    </div>
                    <div class="text-sm font-medium leading-5 text-danger">
                      -6.60%
                    </div>
                  </td>
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      1 week
                    </div>
                    <div class="text-sm font-medium leading-5 text-danger">
                      -9.91%
                    </div>
                  </td>
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      1 month
                    </div>
                    <div class="text-sm font-medium leading-5 text-danger">
                      -18.43%
                    </div>
                  </td>
                </tr>
                <tr
                  class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 border-b border-gray-accent2 md:border-b-0 md:border-r"
                >
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      3 months
                    </div>
                    <div class="text-sm font-medium leading-5 text-danger">
                      -26.71%
                    </div>
                  </td>
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5 border-b border-gray-accent2"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      1 year
                    </div>
                    <div class="text-sm font-medium leading-5 text-danger">
                      -23.73%
                    </div>
                  </td>
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      3 years
                    </div>
                    <div
                      class="text-sm font-medium leading-5 text-bar-chart-green"
                    >
                      +420.46%
                    </div>
                  </td>
                </tr>
                <tr
                  class="block w-auto bg-gray-light px-4 md:w-fit md:bg-transparent md:px-0 md:pr-8 md:last:pr-0 rounded-b-xl md:rounded-none"
                >
                  <td
                    class="flex w-auto items-center justify-between py-4 sm:w-[270px] sm:py-2.5"
                  >
                    <div
                      class="text-sm font-medium leading-5 text-gray-accent3"
                    >
                      5 years
                    </div>
                    <div
                      class="text-sm font-medium leading-5 text-bar-chart-green"
                    >
                      +353.31%
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
        ></div>
        <div class="py-6" id="Revenue statement" data-section="true">
          <div class="flex w-full items-center justify-between cursor-pointer">
            <div
              class="gap-1 text-lighter-black text-base flex flex-col font-semibold leading-6 mb-0"
            >
              <h2>Revenue statement</h2>
              <span class="text-sm text-[#6A6A6A]"
                >All values are in ₹ Crores (Cr)</span
              >
            </div>
            <img
              alt="arrow"
              loading="lazy"
              width="24"
              height="24"
              decoding="async"
              data-nimg="1"
              class="cursor-pointer text-base flex flex-col font-semibold leading-6 mb-0"
              style="color: transparent"
              src="/next-scrip-assets/up-arrow.svg"
            />
          </div>
          <div class="mb-4">
            <ul
              class="no-scrollbar mx-[-16px] mt-4 flex cursor-pointer gap-6 overflow-auto border-b-2 border-gray-accent2 text-center text-base font-medium leading-6 text-gray-accent3 sm:mx-0 mb-4"
            >
              <li class="">
                <div
                  class="inline-block py-2 border-b-2 border-primary-base font-semibold text-primary-base"
                >
                  <h3
                    class="flex gap-1 whitespace-nowrap px-1 py-2 md:hover:rounded md:hover:bg-primary-light md:hover:text-primary-base"
                  >
                    Revenue
                  </h3>
                </div>
              </li>
              <li class="">
                <div class="inline-block py-2">
                  <h3
                    class="flex gap-1 whitespace-nowrap px-1 py-2 md:hover:rounded md:hover:bg-primary-light md:hover:text-primary-base"
                  >
                    Operating profit
                  </h3>
                </div>
              </li>
              <li class="">
                <div class="inline-block py-2">
                  <h3
                    class="flex gap-1 whitespace-nowrap px-1 py-2 md:hover:rounded md:hover:bg-primary-light md:hover:text-primary-base"
                  >
                    Net profit
                  </h3>
                </div>
              </li>
            </ul>
            <div class="mb-4 flex flex-row gap-4">
              <button
                class="cursor-pointer px-4 py-2 disabled:cursor-not-allowed rounded-full border border-gray-accent4 text-[13px] font-semibold leading-5 text-light-black hover:border-primary-base"
              >
                <div class="flex gap-1">
                  <img
                    alt="news logo"
                    loading="lazy"
                    width="16"
                    height="16"
                    decoding="async"
                    data-nimg="1"
                    class="rounded-full"
                    src="/next-scrip-assets/switch.svg"
                    style="color: transparent"
                  />Consolidated
                </div></button
              ><button
                class="cursor-pointer px-4 py-2 disabled:cursor-not-allowed rounded-full border border-gray-accent4 text-[13px] font-semibold leading-5 text-light-black hover:border-primary-base"
              >
                <div class="flex gap-1">
                  <img
                    alt="news logo"
                    loading="lazy"
                    width="16"
                    height="16"
                    decoding="async"
                    data-nimg="1"
                    class="rounded-full"
                    src="/next-scrip-assets/switch.svg"
                    style="color: transparent"
                  />Yearly
                </div>
              </button>
            </div>
            <p
              class="w-fit cursor-pointer pt-4 text-sm font-bold leading-[130%] tracking-[-0.18px] text-primary-base"
            >
              Learn more
            </p>
          </div>
        </div>
        <div
          class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
        ></div>
        <div class="py-6" id="Cash flow" data-section="true">
          <div class="flex w-full items-center justify-between cursor-pointer">
            <div
              class="mb-4 gap-1 text-lighter-black text-base flex flex-col font-semibold leading-6"
            >
              <h2>Cash flow</h2>
              <span class="text-sm text-[#6A6A6A]"
                >All values are in ₹ Crores (Cr)</span
              >
            </div>
            <img
              alt="arrow"
              loading="lazy"
              width="24"
              height="24"
              decoding="async"
              data-nimg="1"
              class="mb-4 cursor-pointer text-base flex flex-col font-semibold leading-6"
              style="color: transparent"
              src="/next-scrip-assets/up-arrow.svg"
            />
          </div>
          <div class="mb-4">
            <ul
              class="no-scrollbar mx-[-16px] mt-4 flex cursor-pointer gap-6 overflow-auto border-b-2 border-gray-accent2 text-center text-base font-medium leading-6 text-gray-accent3 sm:mx-0 mb-4"
            >
              <li class="">
                <div
                  class="inline-block py-2 border-b-2 border-primary-base font-semibold text-primary-base"
                >
                  <h3
                    class="flex gap-1 whitespace-nowrap px-1 py-2 md:hover:rounded md:hover:bg-primary-light md:hover:text-primary-base"
                  >
                    Operating
                  </h3>
                </div>
              </li>
              <li class="">
                <div class="inline-block py-2">
                  <h3
                    class="flex gap-1 whitespace-nowrap px-1 py-2 md:hover:rounded md:hover:bg-primary-light md:hover:text-primary-base"
                  >
                    Investing
                  </h3>
                </div>
              </li>
              <li class="">
                <div class="inline-block py-2">
                  <h3
                    class="flex gap-1 whitespace-nowrap px-1 py-2 md:hover:rounded md:hover:bg-primary-light md:hover:text-primary-base"
                  >
                    Financing
                  </h3>
                </div>
              </li>
            </ul>
            <button
              class="cursor-pointer px-4 py-2 disabled:cursor-not-allowed rounded-full mb-4 mr-4 border border-gray-accent4 text-[13px] font-semibold leading-5 text-light-black hover:border-primary-base"
            >
              <div class="flex gap-1">
                <img
                  alt="news logo"
                  loading="lazy"
                  width="16"
                  height="16"
                  decoding="async"
                  data-nimg="1"
                  class="rounded-full"
                  src="/next-scrip-assets/switch.svg"
                  style="color: transparent"
                />Consolidated
              </div></button
            ><button
              class="cursor-pointer px-4 py-2 disabled:cursor-not-allowed rounded-full mb-4 border border-gray-accent4 text-[13px] font-semibold leading-5 text-light-black opacity-50"
              disabled=""
            >
              <div class="flex gap-1">
                <img
                  alt="news logo"
                  loading="lazy"
                  width="16"
                  height="16"
                  decoding="async"
                  data-nimg="1"
                  class="rounded-full"
                  src="/next-scrip-assets/switch.svg"
                  style="color: transparent"
                />Yearly
              </div>
            </button>
            <p
              class="w-fit cursor-pointer pt-4 text-sm font-bold leading-[130%] tracking-[-0.18px] text-primary-base"
            >
              Learn more
            </p>
          </div>
        </div>
        <div
          class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
        ></div>
        <div class="py-6" id="Balance sheet" data-section="true">
          <div class="flex w-full items-center justify-between cursor-pointer">
            <div
              class="mb-4 gap-1 text-lighter-black text-base flex flex-col font-semibold leading-6"
            >
              <h2>Balance sheet</h2>
              <span class="text-sm text-[#6A6A6A]"
                >All values are in ₹ Crores (Cr)</span
              >
            </div>
            <img
              alt="arrow"
              loading="lazy"
              width="24"
              height="24"
              decoding="async"
              data-nimg="1"
              class="mb-4 cursor-pointer text-base flex flex-col font-semibold leading-6"
              style="color: transparent"
              src="/next-scrip-assets/up-arrow.svg"
            />
          </div>
          <div class="mb-4 flex flex-row gap-4">
            <button
              class="cursor-pointer px-4 py-2 disabled:cursor-not-allowed rounded-full border border-gray-accent4 text-[13px] font-semibold leading-5 text-light-black hover:border-primary-base"
            >
              <div class="flex gap-1">
                <img
                  alt="news logo"
                  loading="lazy"
                  width="16"
                  height="16"
                  decoding="async"
                  data-nimg="1"
                  class="rounded-full"
                  src="/next-scrip-assets/switch.svg"
                  style="color: transparent"
                />Consolidated
              </div></button
            ><button
              class="cursor-pointer px-4 py-2 disabled:cursor-not-allowed rounded-full border border-gray-accent4 text-[13px] font-semibold leading-5 text-light-black opacity-50"
              disabled=""
            >
              <div class="flex gap-1">
                <img
                  alt="news logo"
                  loading="lazy"
                  width="16"
                  height="16"
                  decoding="async"
                  data-nimg="1"
                  class="rounded-full"
                  src="/next-scrip-assets/switch.svg"
                  style="color: transparent"
                />Yearly
              </div>
            </button>
          </div>
          <div class="mb-6 ml-[55px] mt-[20px] flex gap-4">
            <div class="flex items-center gap-2 py-0.5">
              <div
                class="h-4 min-h-[16px] w-4 min-w-[16px] rounded-sm bg-[#0E9AA7]"
              ></div>
              <p
                class="text-[13px] font-medium leading-5 text-[#6A6A6A] md:text-sm"
              >
                Total assets
              </p>
            </div>
            <div class="flex items-center gap-2 py-0.5">
              <div
                class="h-4 min-h-[16px] w-4 min-w-[16px] rounded-sm bg-[#AF91D1]"
              ></div>
              <p
                class="text-[13px] font-medium leading-5 text-[#6A6A6A] md:text-sm"
              >
                Total liabilities
              </p>
            </div>
          </div>
          <p
            class="w-fit cursor-pointer pt-4 text-sm font-bold leading-[130%] tracking-[-0.18px] text-primary-base"
          >
            Learn more
          </p>
        </div>
        <div
          class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
        ></div>
        <div class="py-6" id="Price history" data-section="true">
          <div class="flex w-full items-center justify-between cursor-pointer">
            <div
              class="flex gap-1 text-base font-semibold leading-6 text-lighter-black mb-6"
            >
              <h2>Indian Railway Finance Corp Share Price history</h2>
            </div>
            <img
              alt="arrow"
              loading="lazy"
              width="24"
              height="24"
              decoding="async"
              data-nimg="1"
              class="cursor-pointer text-base font-semibold leading-6 text-lighter-black mb-6"
              style="color: transparent"
              src="/next-scrip-assets/up-arrow.svg"
            />
          </div>
          <div itemscope="" itemtype="https://schema.org/Table">
            <table
              class="w-full table-fixed [&amp;_td]:px-3 sm:[&amp;_td]:px-8 [&amp;_th]:px-3 sm:[&amp;_th]:px-8 rounded-lg text-sm font-semibold shadow-[0_0_0_1px_#E5E5E5]"
            >
              <thead class="">
                <tr>
                  <th
                    class="py-4 text-right font-bold first:rounded-tl-lg first:text-left last:rounded-tr-lg bg-background-base"
                  >
                    Day
                  </th>
                  <th
                    class="py-4 text-right font-bold first:rounded-tl-lg first:text-left last:rounded-tr-lg bg-background-base"
                  >
                    Open
                  </th>
                  <th
                    class="py-4 text-right font-bold first:rounded-tl-lg first:text-left last:rounded-tr-lg bg-background-base"
                  >
                    Close
                  </th>
                  <th
                    class="py-4 text-right font-bold first:rounded-tl-lg first:text-left last:rounded-tr-lg bg-background-base"
                  >
                    Change %
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="group bg-gray-light cursor-default">
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        Fri, Feb 28 2025
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹118.99
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹112.42
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div class="font-normal leading-5x text-sm text-danger">
                        -6.60%
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="group cursor-default">
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        Thu, Feb 27 2025
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹123.50
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹120.36
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div class="font-normal leading-5x text-sm text-danger">
                        -2.35%
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="group bg-gray-light cursor-default">
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        Tue, Feb 25 2025
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹123.40
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹123.26
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div class="font-normal leading-5x text-sm text-danger">
                        -0.17%
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="group cursor-default">
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        Mon, Feb 24 2025
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹124.39
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹123.47
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div class="font-normal leading-5x text-sm text-danger">
                        -1.31%
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="group bg-gray-light cursor-default">
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        Fri, Feb 21 2025
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹124.80
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹125.11
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-bar-chart-green"
                      >
                        +0.26%
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="group cursor-default">
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        Thu, Feb 20 2025
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹123.69
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹124.78
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-bar-chart-green"
                      >
                        +0.41%
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="group bg-gray-light cursor-default">
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        Wed, Feb 19 2025
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹118.20
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹124.27
                      </div>
                    </div>
                  </td>
                  <td class="text-right first:text-left">
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-bar-chart-green"
                      >
                        +4.19%
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="group cursor-default">
                  <td
                    class="text-right first:text-left first:rounded-bl-lg last:rounded-br-lg"
                  >
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        Tue, Feb 18 2025
                      </div>
                    </div>
                  </td>
                  <td
                    class="text-right first:text-left first:rounded-bl-lg last:rounded-br-lg"
                  >
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹121.80
                      </div>
                    </div>
                  </td>
                  <td
                    class="text-right first:text-left first:rounded-bl-lg last:rounded-br-lg"
                  >
                    <div class="block py-4" href="">
                      <div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹119.27
                      </div>
                    </div>
                  </td>
                  <td
                    class="text-right first:text-left first:rounded-bl-lg last:rounded-br-lg"
                  >
                    <div class="block py-4" href="">
                      <div class="font-normal leading-5x text-sm text-danger">
                        -2.06%
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
        ></div>
        <div class="py-6" id="Shareholding info" data-section="true">
          <div class="flex w-full items-center justify-between cursor-pointer">
            <div
              class="mb-4 gap-1 text-lighter-black text-base flex flex-col font-semibold leading-6"
            >
              <h2>Indian Railway Finance Corp Shareholding Pattern</h2>
            </div>
            <img
              alt="arrow"
              loading="lazy"
              width="24"
              height="24"
              decoding="async"
              data-nimg="1"
              class="mb-4 cursor-pointer text-base flex flex-col font-semibold leading-6"
              style="color: transparent"
              src="/next-scrip-assets/up-arrow.svg"
            />
          </div>
          <div
            class="flex flex-col items-start justify-evenly py-8 md:flex-row"
          >
            <div class="w-full gap-8 border-r-0 sm:w-1/2 sm:pr-10 md:border-r">
              <div
                class="recharts-responsive-container"
                style="width: 100%; height: 300px; min-width: 0px"
              >
                <div
                  class="recharts-wrapper outline-none"
                  style="
                    position: relative;
                    cursor: default;
                    width: 100%;
                    height: 100%;
                    max-height: 300px;
                    max-width: 430px;
                  "
                >
                  <svg
                    cx="50%"
                    cy="50%"
                    class="recharts-surface"
                    width="430"
                    height="300"
                    viewBox="0 0 430 300"
                    style="width: 100%; height: 100%"
                  >
                    <title></title>
                    <desc></desc>
                    <defs>
                      <clipPath id="recharts1-clip">
                        <rect x="5" y="5" height="290" width="420"></rect>
                      </clipPath>
                    </defs>
                    <g class="recharts-layer recharts-pie" tabindex="0">
                      <g
                        class="recharts-layer recharts-pie-sector"
                        tabindex="-1"
                      >
                        <g class="recharts-layer recharts-active-shape">
                          <g>
                            <text
                              class="text-4xl font-bold"
                              x="215"
                              y="140"
                              text-anchor="middle"
                            >
                              86.36%
                            </text>
                            <text
                              class="text-base"
                              x="215"
                              y="165"
                              text-anchor="middle"
                            >
                              Promoters
                            </text>
                            <text
                              class="text-sm"
                              x="215"
                              y="190"
                              text-anchor="middle"
                              fill="#6A6A6A"
                            >
                              Dec 2024
                            </text>
                            <path
                              cx="215"
                              cy="150"
                              fill="#FDBD4D"
                              class="recharts-sector"
                              d="M 359,150
    A 144,144,0,
    1,0,
    309.27507827768295,258.8494814674684
  L 287.0156847954523,233.14890945431614
            A 110,110,0,
            1,1,
            325,150 Z"
                              role="img"
                            ></path>
                          </g>
                        </g>
                      </g>
                      <g
                        class="recharts-layer recharts-pie-sector"
                        tabindex="-1"
                      >
                        <path
                          cx="215"
                          cy="150"
                          name="1"
                          fill="#FD9172"
                          stroke="#fff"
                          class="recharts-sector outline-none"
                          tabindex="-1"
                          d="M 306.6563261033029,255.82588476003875
    A 140,140,0,
    0,0,
    313.18305128264905,249.8002426892275
  L 292.14382600779567,228.41447639867874
            A 110,110,0,
            0,1,
            287.0156847954523,233.14890945431614 Z"
                          role="img"
                        ></path>
                      </g>
                      <g
                        class="recharts-layer recharts-pie-sector"
                        tabindex="-1"
                      >
                        <path
                          cx="215"
                          cy="150"
                          name="2"
                          fill="#923C27"
                          stroke="#fff"
                          class="recharts-sector outline-none"
                          tabindex="-1"
                          d="M 313.18305128264905,249.8002426892275
    A 140,140,0,
    0,0,
    319.2558185463356,243.43834490846643
  L 296.9152860006923,223.4158424280808
            A 110,110,0,
            0,1,
            292.14382600779567,228.41447639867874 Z"
                          role="img"
                        ></path>
                      </g>
                      <g
                        class="recharts-layer recharts-pie-sector"
                        tabindex="-1"
                      >
                        <path
                          cx="215"
                          cy="150"
                          name="3"
                          fill="#7DCECD"
                          stroke="#fff"
                          class="recharts-sector outline-none"
                          tabindex="-1"
                          d="M 319.2558185463356,243.43834490846643
    A 140,140,0,
    0,0,
    354.9840826036543,152.11107025304509
  L 324.9874934742998,151.65869805596398
            A 110,110,0,
            0,1,
            296.9152860006923,223.4158424280808 Z"
                          role="img"
                        ></path>
                      </g>
                      <g
                        class="recharts-layer recharts-pie-sector"
                        tabindex="-1"
                      >
                        <path
                          cx="215"
                          cy="150"
                          name="4"
                          fill="#AF91D1"
                          stroke="#fff"
                          class="recharts-sector outline-none"
                          tabindex="-1"
                          d="M 354.9840826036543,152.11107025304509
    A 140,140,0,
    0,0,
    355,149.99999999999991
  L 325,149.99999999999994
            A 110,110,0,
            0,1,
            324.9874934742998,151.65869805596398 Z"
                          role="img"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
              <table>
                <tbody
                  class="mb-8 mt-8 flex flex-row justify-between gap-4 sm:mb-0 sm:mt-4"
                >
                  <tr>
                    <td class="flex items-center gap-2 py-2">
                      <div class="flex items-center gap-2 py-0.5">
                        <div
                          class="h-4 min-h-[16px] w-4 min-w-[16px] rounded-sm bg-[#FDBD4D]"
                        ></div>
                        <p
                          class="text-[13px] font-medium leading-5 text-[#6A6A6A] md:text-sm"
                        >
                          Promoters (86.36%)
                        </p>
                      </div>
                    </td>
                    <td class="flex items-center gap-2 py-2">
                      <div class="flex items-center gap-2 py-0.5">
                        <div
                          class="h-4 min-h-[16px] w-4 min-w-[16px] rounded-sm bg-[#AF91D1]"
                        ></div>
                        <p
                          class="text-[13px] font-medium leading-5 text-[#6A6A6A] md:text-sm"
                        >
                          Mutual Funds (0.24%)
                        </p>
                      </div>
                    </td>
                    <td class="flex items-center gap-2 py-2">
                      <div class="flex items-center gap-2 py-0.5">
                        <div
                          class="h-4 min-h-[16px] w-4 min-w-[16px] rounded-sm bg-[#7DCECD]"
                        ></div>
                        <p
                          class="text-[13px] font-medium leading-5 text-[#6A6A6A] md:text-sm"
                        >
                          Retail and other (11.39%)
                        </p>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="flex items-center gap-2 py-2">
                      <div class="flex items-center gap-2 py-0.5">
                        <div
                          class="h-4 min-h-[16px] w-4 min-w-[16px] rounded-sm bg-[#FD9172]"
                        ></div>
                        <p
                          class="text-[13px] font-medium leading-5 text-[#6A6A6A] md:text-sm"
                        >
                          Foreign institutions-FII (1.01%)
                        </p>
                      </div>
                    </td>
                    <td class="flex items-center gap-2 py-2">
                      <div class="flex items-center gap-2 py-0.5">
                        <div
                          class="h-4 min-h-[16px] w-4 min-w-[16px] rounded-sm bg-[#923C27]"
                        ></div>
                        <p
                          class="text-[13px] font-medium leading-5 text-[#6A6A6A] md:text-sm"
                        >
                          Other domestic institutions (1%)
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="flex h-[380px] w-full flex-col gap-4 sm:w-1/2 sm:pl-10">
              <span
                class="py-2 text-left text-base font-medium leading-[26px] tracking-normal sm:py-0"
                >Promoters</span
              >
              <div
                class="recharts-responsive-container"
                style="width: 100%; height: 100%; min-width: 0px"
              >
                <div
                  class="recharts-wrapper"
                  style="
                    position: relative;
                    cursor: default;
                    width: 100%;
                    height: 100%;
                    max-height: 338px;
                    max-width: 431px;
                  "
                >
                  <svg
                    class="recharts-surface"
                    width="431"
                    height="338"
                    viewBox="0 0 431 338"
                    style="width: 100%; height: 100%"
                  >
                    <title></title>
                    <desc></desc>
                    <defs>
                      <clipPath id="recharts3-clip">
                        <rect x="35" y="30" height="278" width="396"></rect>
                      </clipPath>
                    </defs>
                    <g class="recharts-cartesian-grid">
                      <g class="recharts-cartesian-grid-horizontal">
                        <line
                          stroke-opacity="0.8"
                          stroke="#ccc"
                          fill="none"
                          x="35"
                          y="30"
                          width="396"
                          height="278"
                          x1="35"
                          y1="308"
                          x2="431"
                          y2="308"
                        ></line>
                        <line
                          stroke-opacity="0.8"
                          stroke="#ccc"
                          fill="none"
                          x="35"
                          y="30"
                          width="396"
                          height="278"
                          x1="35"
                          y1="238.5"
                          x2="431"
                          y2="238.5"
                        ></line>
                        <line
                          stroke-opacity="0.8"
                          stroke="#ccc"
                          fill="none"
                          x="35"
                          y="30"
                          width="396"
                          height="278"
                          x1="35"
                          y1="169"
                          x2="431"
                          y2="169"
                        ></line>
                        <line
                          stroke-opacity="0.8"
                          stroke="#ccc"
                          fill="none"
                          x="35"
                          y="30"
                          width="396"
                          height="278"
                          x1="35"
                          y1="99.5"
                          x2="431"
                          y2="99.5"
                        ></line>
                        <line
                          stroke-opacity="0.8"
                          stroke="#ccc"
                          fill="none"
                          x="35"
                          y="30"
                          width="396"
                          height="278"
                          x1="35"
                          y1="30"
                          x2="431"
                          y2="30"
                        ></line>
                      </g>
                    </g>
                    <g
                      class="recharts-layer recharts-cartesian-axis recharts-xAxis xAxis"
                    >
                      <g class="recharts-cartesian-axis-ticks">
                        <g class="recharts-layer recharts-cartesian-axis-tick">
                          <text
                            orientation="bottom"
                            width="396"
                            height="30"
                            stroke="none"
                            font-size="13"
                            x="84.5"
                            y="316"
                            class="recharts-text recharts-cartesian-axis-tick-value"
                            text-anchor="middle"
                            fill="#666"
                          >
                            <tspan x="84.5" dy="0.71em">Mar 2024</tspan>
                          </text>
                        </g>
                        <g class="recharts-layer recharts-cartesian-axis-tick">
                          <text
                            orientation="bottom"
                            width="396"
                            height="30"
                            stroke="none"
                            font-size="13"
                            x="183.5"
                            y="316"
                            class="recharts-text recharts-cartesian-axis-tick-value"
                            text-anchor="middle"
                            fill="#666"
                          >
                            <tspan x="183.5" dy="0.71em">Jun 2024</tspan>
                          </text>
                        </g>
                        <g class="recharts-layer recharts-cartesian-axis-tick">
                          <text
                            orientation="bottom"
                            width="396"
                            height="30"
                            stroke="none"
                            font-size="13"
                            x="282.5"
                            y="316"
                            class="recharts-text recharts-cartesian-axis-tick-value"
                            text-anchor="middle"
                            fill="#666"
                          >
                            <tspan x="282.5" dy="0.71em">Sep 2024</tspan>
                          </text>
                        </g>
                        <g class="recharts-layer recharts-cartesian-axis-tick">
                          <text
                            orientation="bottom"
                            width="396"
                            height="30"
                            stroke="none"
                            font-size="13"
                            x="381.5"
                            y="316"
                            class="recharts-text recharts-cartesian-axis-tick-value"
                            text-anchor="middle"
                            fill="#666"
                          >
                            <tspan x="381.5" dy="0.71em">Dec 2024</tspan>
                          </text>
                        </g>
                      </g>
                    </g>
                    <g
                      class="recharts-layer recharts-cartesian-axis recharts-yAxis yAxis"
                    >
                      <g class="recharts-cartesian-axis-ticks">
                        <g class="recharts-layer recharts-cartesian-axis-tick">
                          <text
                            orientation="left"
                            width="60"
                            height="278"
                            stroke="none"
                            font-size="13"
                            x="27"
                            y="308"
                            class="recharts-text recharts-cartesian-axis-tick-value"
                            text-anchor="end"
                            fill="#666"
                          >
                            <tspan x="27" dy="0.355em">0</tspan>
                          </text>
                        </g>
                        <g class="recharts-layer recharts-cartesian-axis-tick">
                          <text
                            orientation="left"
                            width="60"
                            height="278"
                            stroke="none"
                            font-size="13"
                            x="27"
                            y="238.5"
                            class="recharts-text recharts-cartesian-axis-tick-value"
                            text-anchor="end"
                            fill="#666"
                          >
                            <tspan x="27" dy="0.355em">25</tspan>
                          </text>
                        </g>
                        <g class="recharts-layer recharts-cartesian-axis-tick">
                          <text
                            orientation="left"
                            width="60"
                            height="278"
                            stroke="none"
                            font-size="13"
                            x="27"
                            y="169"
                            class="recharts-text recharts-cartesian-axis-tick-value"
                            text-anchor="end"
                            fill="#666"
                          >
                            <tspan x="27" dy="0.355em">50</tspan>
                          </text>
                        </g>
                        <g class="recharts-layer recharts-cartesian-axis-tick">
                          <text
                            orientation="left"
                            width="60"
                            height="278"
                            stroke="none"
                            font-size="13"
                            x="27"
                            y="99.5"
                            class="recharts-text recharts-cartesian-axis-tick-value"
                            text-anchor="end"
                            fill="#666"
                          >
                            <tspan x="27" dy="0.355em">75</tspan>
                          </text>
                        </g>
                        <g class="recharts-layer recharts-cartesian-axis-tick">
                          <text
                            orientation="left"
                            width="60"
                            height="278"
                            stroke="none"
                            font-size="13"
                            x="27"
                            y="30"
                            class="recharts-text recharts-cartesian-axis-tick-value"
                            text-anchor="end"
                            fill="#666"
                          >
                            <tspan x="27" dy="0.355em">100</tspan>
                          </text>
                        </g>
                      </g>
                    </g>
                    <g class="recharts-layer recharts-bar">
                      <g class="recharts-layer recharts-bar-rectangles">
                        <g class="recharts-layer">
                          <g class="recharts-layer recharts-bar-rectangle">
                            <path
                              x="54"
                              y="67.91919999999999"
                              width="60"
                              height="240.0808"
                              radius="4,4,0,0"
                              fill="#FDBD4D"
                              class="recharts-rectangle"
                              d="M54,71.91919999999999A 4,4,0,0,1,58,67.91919999999999L 110,67.91919999999999A 4,4,0,0,1,
        114,71.91919999999999L 114,308L 54,308Z"
                            ></path>
                          </g>
                          <g class="recharts-layer recharts-bar-rectangle">
                            <path
                              x="153"
                              y="67.91919999999999"
                              width="60"
                              height="240.0808"
                              radius="4,4,0,0"
                              fill="#FDBD4D"
                              class="recharts-rectangle"
                              d="M153,71.91919999999999A 4,4,0,0,1,157,67.91919999999999L 209,67.91919999999999A 4,4,0,0,1,
        213,71.91919999999999L 213,308L 153,308Z"
                            ></path>
                          </g>
                          <g class="recharts-layer recharts-bar-rectangle">
                            <path
                              x="252"
                              y="67.91919999999999"
                              width="60"
                              height="240.0808"
                              radius="4,4,0,0"
                              fill="#FDBD4D"
                              class="recharts-rectangle"
                              d="M252,71.91919999999999A 4,4,0,0,1,256,67.91919999999999L 308,67.91919999999999A 4,4,0,0,1,
        312,71.91919999999999L 312,308L 252,308Z"
                            ></path>
                          </g>
                          <g class="recharts-layer recharts-bar-rectangle">
                            <path
                              x="351"
                              y="67.91919999999999"
                              width="60"
                              height="240.0808"
                              radius="4,4,0,0"
                              fill="#FDBD4D"
                              class="recharts-rectangle"
                              d="M351,71.91919999999999A 4,4,0,0,1,355,67.91919999999999L 407,67.91919999999999A 4,4,0,0,1,
        411,71.91919999999999L 411,308L 351,308Z"
                            ></path>
                          </g>
                        </g>
                      </g>
                      <g class="recharts-layer"></g>
                      <g class="recharts-layer recharts-label-list">
                        <text
                          offset="5"
                          width="60"
                          height="240.0808"
                          font-size="13"
                          x="84"
                          y="62.91919999999999"
                          class="recharts-text recharts-label"
                          text-anchor="middle"
                          fill="#6A6A6A"
                        >
                          <tspan x="84" dy="0em">86.36%</tspan>
                        </text>
                        <text
                          offset="5"
                          width="60"
                          height="240.0808"
                          font-size="13"
                          x="183"
                          y="62.91919999999999"
                          class="recharts-text recharts-label"
                          text-anchor="middle"
                          fill="#6A6A6A"
                        >
                          <tspan x="183" dy="0em">86.36%</tspan>
                        </text>
                        <text
                          offset="5"
                          width="60"
                          height="240.0808"
                          font-size="13"
                          x="282"
                          y="62.91919999999999"
                          class="recharts-text recharts-label"
                          text-anchor="middle"
                          fill="#6A6A6A"
                        >
                          <tspan x="282" dy="0em">86.36%</tspan>
                        </text>
                        <text
                          offset="5"
                          width="60"
                          height="240.0808"
                          font-size="13"
                          x="381"
                          y="62.91919999999999"
                          class="recharts-text recharts-label"
                          text-anchor="middle"
                          fill="#6A6A6A"
                        >
                          <tspan x="381" dy="0em">86.36%</tspan>
                        </text>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <p
            class="w-fit cursor-pointer text-sm font-bold leading-[130%] tracking-[-0.18px] text-primary-base"
          >
            Learn more
          </p>
        </div>
        <div
          class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
        ></div>
        <div class="py-6" id="Events" data-section="true">
          <div class="flex w-full items-center justify-between">
            <div
              class="mb-4 flex gap-1 text-xl font-semibold leading-7 text-lighter-black"
            >
              <h2>Events</h2>
            </div>
          </div>
          <div class="py-0" id="Corporate actions" data-section="true">
            <div
              class="flex w-full items-center justify-between cursor-pointer"
            >
              <div
                class="mb-4 flex gap-1 text-lighter-black text-base font-semibold"
              >
                <h2>Corporate actions</h2>
              </div>
              <img
                alt="arrow"
                loading="lazy"
                width="24"
                height="24"
                decoding="async"
                data-nimg="1"
                class="mb-4 cursor-pointer text-base font-semibold"
                style="color: transparent"
                src="/next-scrip-assets/up-arrow.svg"
              />
            </div>
            <div class="flex">
              <ul
                class="flex-column rounded-bl-2xl rounded-tl-2xl border-b border-l border-gray-accent2 font-medium"
              >
                <li
                  class="cursor-pointer hover:bg-primary-light bg-gray-light md:bg-primary-light rounded-t-lg border-t border-gray-accent2 md:rounded-tl-2xl md:rounded-tr-none"
                >
                  <div
                    class="flex w-[328px] justify-between p-4 md:w-[422px] md:p-6"
                  >
                    <div>
                      <p
                        class="text-base leading-6 md:font-semibold md:text-primary-base"
                      >
                        Dividend • ₹0.8/share
                      </p>
                      <p class="text-[13px] leading-5 text-gray-accent3">
                        Ex date 12 Nov 2024
                      </p>
                    </div>
                    <img
                      alt="expand tab"
                      loading="lazy"
                      width="24"
                      height="24"
                      decoding="async"
                      data-nimg="1"
                      style="color: transparent"
                      src="/next-scrip-assets/tab-right-arrow-purple.svg"
                    />
                  </div>
                </li>
                <li class="cursor-pointer hover:bg-primary-light bg-gray-light">
                  <div
                    class="flex w-[328px] justify-between p-4 md:w-[422px] md:p-6"
                  >
                    <div>
                      <p class="text-base leading-6">Dividend • ₹0.7/share</p>
                      <p class="text-[13px] leading-5 text-gray-accent3">
                        Ex date 22 Aug 2024
                      </p>
                    </div>
                    <img
                      alt="expand tab"
                      loading="lazy"
                      width="24"
                      height="24"
                      decoding="async"
                      data-nimg="1"
                      style="color: transparent"
                      src="/next-scrip-assets/tab-right-arrow-black.svg"
                    />
                  </div>
                </li>
                <li class="cursor-pointer hover:bg-primary-light bg-gray-light">
                  <div
                    class="flex w-[328px] justify-between p-4 md:w-[422px] md:p-6"
                  >
                    <div>
                      <p class="text-base leading-6">Dividend • ₹0.8/share</p>
                      <p class="text-[13px] leading-5 text-gray-accent3">
                        Ex date 10 Nov 2023
                      </p>
                    </div>
                    <img
                      alt="expand tab"
                      loading="lazy"
                      width="24"
                      height="24"
                      decoding="async"
                      data-nimg="1"
                      style="color: transparent"
                      src="/next-scrip-assets/tab-right-arrow-black.svg"
                    />
                  </div>
                </li>
                <li class="cursor-pointer hover:bg-primary-light bg-gray-light">
                  <div
                    class="flex w-[328px] justify-between p-4 md:w-[422px] md:p-6"
                  >
                    <div>
                      <p class="text-base leading-6">Dividend • ₹0.7/share</p>
                      <p class="text-[13px] leading-5 text-gray-accent3">
                        Ex date 15 Sep 2023
                      </p>
                    </div>
                    <img
                      alt="expand tab"
                      loading="lazy"
                      width="24"
                      height="24"
                      decoding="async"
                      data-nimg="1"
                      style="color: transparent"
                      src="/next-scrip-assets/tab-right-arrow-black.svg"
                    />
                  </div>
                </li>
              </ul>
              <div
                class="text-medium hidden w-full rounded-r-2xl border border-gray-accent2 px-6 md:block"
              >
                <div class="flex flex-col gap-2 p-4 sm:hidden">
                  <span class="text-xl font-semibold">Dividend</span
                  ><span class="text-[#6A6A6A]">₹0.8 per share</span>
                </div>
                <div class="hidden flex-col gap-2 pb-4 pt-6 md:flex">
                  <h3 class="text-base font-semibold leading-6">Dividend</h3>
                  <p class="text-base font-medium leading-6 text-gray-accent3">
                    ₹0.8 per share
                  </p>
                </div>
                <div itemscope="" itemtype="https://schema.org/Table">
                  <table class="w-full">
                    <tbody>
                      <tr
                        class="block px-4 md:bg-transparent md:px-0 md:last:pr-0 w-full bg-transparent md:w-auto md:pr-0"
                      >
                        <td
                          class="flex items-center justify-between sm:w-[270px] w-full md:w-auto py-3.5 sm:py-4 border-b border-gray-accent2"
                        >
                          <h3
                            class="text-sm font-medium leading-5 text-gray-accent3"
                          >
                            Announcement date
                          </h3>
                          <div
                            class="text-sm font-medium leading-5 text-light-black sm:py-1.5"
                          >
                            22 Oct 2024
                          </div>
                        </td>
                        <td
                          class="flex items-center justify-between sm:w-[270px] w-full md:w-auto py-3.5 sm:py-4 border-b border-gray-accent2"
                        >
                          <h3
                            class="text-sm font-medium leading-5 text-gray-accent3"
                          >
                            Ex dividend date
                          </h3>
                          <div
                            class="text-sm font-medium leading-5 text-light-black sm:py-1.5"
                          >
                            12 Nov 2024
                          </div>
                        </td>
                        <td
                          class="flex items-center justify-between sm:w-[270px] w-full md:w-auto py-3.5 sm:py-4 border-b border-gray-accent2"
                        >
                          <h3
                            class="text-sm font-medium leading-5 text-gray-accent3"
                          >
                            Record date
                          </h3>
                          <div
                            class="text-sm font-medium leading-5 text-light-black sm:py-1.5"
                          >
                            12 Nov 2024
                          </div>
                        </td>
                        <td
                          class="flex items-center justify-between sm:w-[270px] w-full md:w-auto py-3.5 sm:py-4 border-b border-gray-accent2"
                        >
                          <h3
                            class="text-sm font-medium leading-5 text-gray-accent3"
                          >
                            Dividend type
                          </h3>
                          <div
                            class="text-sm font-medium leading-5 text-light-black sm:py-1.5"
                          >
                            Interim
                          </div>
                        </td>
                        <td
                          class="flex items-center justify-between sm:w-[270px] w-full md:w-auto py-3.5 sm:py-4 border-b border-gray-accent2"
                        >
                          <h3
                            class="text-sm font-medium leading-5 text-gray-accent3"
                          >
                            Amount
                          </h3>
                          <div
                            class="text-sm font-medium leading-5 text-light-black sm:py-1.5"
                          >
                            ₹0.8
                          </div>
                        </td>
                        <td
                          class="flex items-center justify-between sm:w-[270px] w-full md:w-auto py-3.5 sm:py-4"
                        >
                          <h3
                            class="text-sm font-medium leading-5 text-gray-accent3"
                          >
                            Dividend %
                          </h3>
                          <div
                            class="text-sm font-medium leading-5 text-light-black sm:py-1.5"
                          >
                            8.0%
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <p
              class="w-fit cursor-pointer pt-6 text-sm font-bold leading-[130%] tracking-[-0.18px] text-primary-base"
            >
              Learn more
            </p>
          </div>
        </div>
        <div
          class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
        ></div>
        <div class="py-6" id="F&amp;O" data-section="true">
          <div class="flex w-full items-center justify-between cursor-pointer">
            <div
              class="flex gap-1 text-xl font-semibold leading-7 text-lighter-black mb-2"
            >
              <h2>Indian Railway Finance Corp Futures &amp; Options</h2>
            </div>
            <img
              alt="arrow"
              loading="lazy"
              width="24"
              height="24"
              decoding="async"
              data-nimg="1"
              class="cursor-pointer mb-2"
              style="color: transparent"
              src="/next-scrip-assets/up-arrow.svg"
            />
          </div>
          <div class="mt-2 flex flex-col gap-2 md:mt-4 md:flex-row md:gap-4">
            <a
              target="_blank"
              class="w-full"
              href="/option-chain/indian-railway-fin-corp-l/"
              ><div
                class="group flex h-[74px] max-h-[74px] w-full items-center rounded-lg bg-[#F5F5F5] p-4 hover:bg-[#F2ECFD]"
              >
                <div
                  class="flex w-full shrink-0 items-center justify-between self-stretch"
                >
                  <div class="flex flex-row items-center gap-2 self-stretch">
                    <img
                      alt="stock logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/NSE_EQ|INE053F01010.png"
                    />
                    <div
                      class="flex flex-col items-start justify-between gap-0.5"
                    >
                      <span
                        class="overflow-hidden text-ellipsis text-sm font-semibold text-[#101010] group-hover:text-[#41246E]"
                        >Indian Railway Finance Corp Option Chain</span
                      ><span
                        class="text-[13px] font-medium leading-5 text-[#6A6A6A]"
                        >View Price, OI, Greeks and more...</span
                      >
                    </div>
                  </div>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      class="fill-[#101010] group-hover:fill-[#5A2989]"
                    >
                      <path
                        d="M10.6688 6.27614L4.93109 12.0139L3.98828 11.0711L9.72601 5.33333H4.66883V4H12.0021V11.3333H10.6688V6.27614Z"
                      ></path>
                    </svg>
                  </div>
                </div></div
            ></a>
          </div>
          <ul
            class="no-scrollbar mx-[-16px] mt-4 flex cursor-pointer gap-6 overflow-auto border-b-2 border-gray-accent2 text-center text-gray-accent3 sm:mx-0 mb-4 text-base font-medium leading-6"
          >
            <li class="">
              <div class="inline-block py-2">
                <h3
                  class="flex gap-1 whitespace-nowrap px-1 py-2 md:hover:rounded md:hover:bg-primary-light md:hover:text-primary-base"
                >
                  Indian Railway Finance Corp Options
                </h3>
              </div>
            </li>
            <li class="">
              <div class="inline-block py-2">
                <h3
                  class="flex gap-1 whitespace-nowrap px-1 py-2 md:hover:rounded md:hover:bg-primary-light md:hover:text-primary-base"
                >
                  Indian Railway Finance Corp Futures
                </h3>
              </div>
            </li>
          </ul>
          <div itemscope="" itemtype="https://schema.org/Table">
            <table
              class="w-full table-fixed [&amp;_th]:px-3 sm:[&amp;_th]:px-8 mb-4 rounded-lg text-sm font-semibold shadow-[0_0_0_1px_#E5E5E5] [&amp;_td]:px-0 sm:[&amp;_td]:px-0"
            >
              <thead class="">
                <tr>
                  <th
                    class="py-4 text-right font-bold first:rounded-tl-lg first:text-left last:rounded-tr-lg bg-background-base"
                  >
                    Expiry dates
                  </th>
                  <th
                    class="py-4 text-right font-bold first:rounded-tl-lg first:text-left last:rounded-tr-lg bg-background-base"
                  >
                    Current price
                  </th>
                  <th
                    class="py-4 text-right font-bold first:rounded-tl-lg first:text-left last:rounded-tr-lg bg-background-base"
                  >
                    Change %
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="group cursor-pointer bg-gray-light futures-options-hover-state"
                >
                  <td class="text-right first:text-left">
                    <a
                      class="py-4 flex flex-row items-center gap-1 px-3 sm:px-8"
                      target="_blank"
                      href="/options-live/indian-railway-fin-corp-l-call-put-option-price/27Mar120CE/"
                      ><div
                        class="font-normal leading-5x text-sm text-lighter-black group-hover:text-primary-base"
                      >
                        IRFC 120 CE 27 MAR 25
                      </div>
                      <div class="hidden group-hover:block">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          class="fill-[#101010] group-hover:fill-[#5A2989]"
                        >
                          <path
                            d="M10.6688 6.27614L4.93109 12.0139L3.98828 11.0711L9.72601 5.33333H4.66883V4H12.0021V11.3333H10.6688V6.27614Z"
                          ></path>
                        </svg></div
                    ></a>
                  </td>
                  <td class="text-right first:text-left">
                    <a
                      class="block py-4 px-3 sm:px-8"
                      target="_blank"
                      href="/options-live/indian-railway-fin-corp-l-call-put-option-price/27Mar120CE/"
                      ><div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹1.25
                      </div></a
                    >
                  </td>
                  <td class="text-right first:text-left">
                    <a
                      class="block py-4 px-3 sm:px-8"
                      target="_blank"
                      href="/options-live/indian-railway-fin-corp-l-call-put-option-price/27Mar120CE/"
                      ><div class="font-normal leading-5x text-sm text-danger">
                        -₹1.15 (-47.92%)
                      </div></a
                    >
                  </td>
                </tr>
                <tr class="group cursor-pointer futures-options-hover-state">
                  <td class="text-right first:text-left">
                    <a
                      class="py-4 flex flex-row items-center gap-1 px-3 sm:px-8"
                      target="_blank"
                      href="/options-live/indian-railway-fin-corp-l-call-put-option-price/27Mar130CE/"
                      ><div
                        class="font-normal leading-5x text-sm text-lighter-black group-hover:text-primary-base"
                      >
                        IRFC 130 CE 27 MAR 25
                      </div>
                      <div class="hidden group-hover:block">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          class="fill-[#101010] group-hover:fill-[#5A2989]"
                        >
                          <path
                            d="M10.6688 6.27614L4.93109 12.0139L3.98828 11.0711L9.72601 5.33333H4.66883V4H12.0021V11.3333H10.6688V6.27614Z"
                          ></path>
                        </svg></div
                    ></a>
                  </td>
                  <td class="text-right first:text-left">
                    <a
                      class="block py-4 px-3 sm:px-8"
                      target="_blank"
                      href="/options-live/indian-railway-fin-corp-l-call-put-option-price/27Mar130CE/"
                      ><div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹0.55
                      </div></a
                    >
                  </td>
                  <td class="text-right first:text-left">
                    <a
                      class="block py-4 px-3 sm:px-8"
                      target="_blank"
                      href="/options-live/indian-railway-fin-corp-l-call-put-option-price/27Mar130CE/"
                      ><div class="font-normal leading-5x text-sm text-danger">
                        -₹0.45 (-45%)
                      </div></a
                    >
                  </td>
                </tr>
                <tr
                  class="group cursor-pointer bg-gray-light futures-options-hover-state"
                >
                  <td class="text-right first:text-left">
                    <a
                      class="py-4 flex flex-row items-center gap-1 px-3 sm:px-8"
                      target="_blank"
                      href="/options-live/indian-railway-fin-corp-l-call-put-option-price/27Mar115CE/"
                      ><div
                        class="font-normal leading-5x text-sm text-lighter-black group-hover:text-primary-base"
                      >
                        IRFC 115 CE 27 MAR 25
                      </div>
                      <div class="hidden group-hover:block">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          class="fill-[#101010] group-hover:fill-[#5A2989]"
                        >
                          <path
                            d="M10.6688 6.27614L4.93109 12.0139L3.98828 11.0711L9.72601 5.33333H4.66883V4H12.0021V11.3333H10.6688V6.27614Z"
                          ></path>
                        </svg></div
                    ></a>
                  </td>
                  <td class="text-right first:text-left">
                    <a
                      class="block py-4 px-3 sm:px-8"
                      target="_blank"
                      href="/options-live/indian-railway-fin-corp-l-call-put-option-price/27Mar115CE/"
                      ><div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹2.00
                      </div></a
                    >
                  </td>
                  <td class="text-right first:text-left">
                    <a
                      class="block py-4 px-3 sm:px-8"
                      target="_blank"
                      href="/options-live/indian-railway-fin-corp-l-call-put-option-price/27Mar115CE/"
                      ><div class="font-normal leading-5x text-sm text-danger">
                        -₹1.65 (-45.21%)
                      </div></a
                    >
                  </td>
                </tr>
                <tr class="group cursor-pointer futures-options-hover-state">
                  <td
                    class="text-right first:text-left first:rounded-bl-lg last:rounded-br-lg"
                  >
                    <a
                      class="py-4 flex flex-row items-center gap-1 px-3 sm:px-8"
                      target="_blank"
                      href="/options-live/indian-railway-fin-corp-l-call-put-option-price/27Mar125CE/"
                      ><div
                        class="font-normal leading-5x text-sm text-lighter-black group-hover:text-primary-base"
                      >
                        IRFC 125 CE 27 MAR 25
                      </div>
                      <div class="hidden group-hover:block">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          class="fill-[#101010] group-hover:fill-[#5A2989]"
                        >
                          <path
                            d="M10.6688 6.27614L4.93109 12.0139L3.98828 11.0711L9.72601 5.33333H4.66883V4H12.0021V11.3333H10.6688V6.27614Z"
                          ></path>
                        </svg></div
                    ></a>
                  </td>
                  <td
                    class="text-right first:text-left first:rounded-bl-lg last:rounded-br-lg"
                  >
                    <a
                      class="block py-4 px-3 sm:px-8"
                      target="_blank"
                      href="/options-live/indian-railway-fin-corp-l-call-put-option-price/27Mar125CE/"
                      ><div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹0.85
                      </div></a
                    >
                  </td>
                  <td
                    class="text-right first:text-left first:rounded-bl-lg last:rounded-br-lg"
                  >
                    <a
                      class="block py-4 px-3 sm:px-8"
                      target="_blank"
                      href="/options-live/indian-railway-fin-corp-l-call-put-option-price/27Mar125CE/"
                      ><div class="font-normal leading-5x text-sm text-danger">
                        -₹0.70 (-45.16%)
                      </div></a
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              class="w-full table-fixed [&amp;_td]:px-3 sm:[&amp;_td]:px-8 [&amp;_th]:px-3 sm:[&amp;_th]:px-8 hidden"
            >
              <thead class="">
                <tr>
                  <th
                    class="py-4 text-right font-bold first:rounded-tl-lg first:text-left last:rounded-tr-lg bg-background-base"
                  >
                    Expiry dates
                  </th>
                  <th
                    class="py-4 text-right font-bold first:rounded-tl-lg first:text-left last:rounded-tr-lg bg-background-base"
                  >
                    Current price
                  </th>
                  <th
                    class="py-4 text-right font-bold first:rounded-tl-lg first:text-left last:rounded-tr-lg bg-background-base"
                  >
                    Change %
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="group cursor-pointer bg-gray-light futures-options-hover-state"
                >
                  <td class="text-right first:text-left">
                    <a
                      class="py-4 flex flex-row items-center gap-1 px-3 sm:px-8"
                      target="_blank"
                      href="/futures-live/indian-railway-fin-corp-l-future-share-price/29May25/"
                      ><div
                        class="font-normal leading-5x text-sm text-lighter-black group-hover:text-primary-base"
                      >
                        IRFC FUT 29 MAY 25
                      </div>
                      <div class="hidden group-hover:block">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          class="fill-[#101010] group-hover:fill-[#5A2989]"
                        >
                          <path
                            d="M10.6688 6.27614L4.93109 12.0139L3.98828 11.0711L9.72601 5.33333H4.66883V4H12.0021V11.3333H10.6688V6.27614Z"
                          ></path>
                        </svg></div
                    ></a>
                  </td>
                  <td class="text-right first:text-left">
                    <a
                      class="block py-4 px-3 sm:px-8"
                      target="_blank"
                      href="/futures-live/indian-railway-fin-corp-l-future-share-price/29May25/"
                      ><div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹110.28
                      </div></a
                    >
                  </td>
                  <td class="text-right first:text-left">
                    <a
                      class="block py-4 px-3 sm:px-8"
                      target="_blank"
                      href="/futures-live/indian-railway-fin-corp-l-future-share-price/29May25/"
                      ><div class="font-normal leading-5x text-sm text-danger">
                        -₹12.25 (-10%)
                      </div></a
                    >
                  </td>
                </tr>
                <tr class="group cursor-pointer futures-options-hover-state">
                  <td class="text-right first:text-left">
                    <a
                      class="py-4 flex flex-row items-center gap-1 px-3 sm:px-8"
                      target="_blank"
                      href="/futures-live/indian-railway-fin-corp-l-future-share-price/24Apr25/"
                      ><div
                        class="font-normal leading-5x text-sm text-lighter-black group-hover:text-primary-base"
                      >
                        IRFC FUT 24 APR 25
                      </div>
                      <div class="hidden group-hover:block">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          class="fill-[#101010] group-hover:fill-[#5A2989]"
                        >
                          <path
                            d="M10.6688 6.27614L4.93109 12.0139L3.98828 11.0711L9.72601 5.33333H4.66883V4H12.0021V11.3333H10.6688V6.27614Z"
                          ></path>
                        </svg></div
                    ></a>
                  </td>
                  <td class="text-right first:text-left">
                    <a
                      class="block py-4 px-3 sm:px-8"
                      target="_blank"
                      href="/futures-live/indian-railway-fin-corp-l-future-share-price/24Apr25/"
                      ><div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹98.35
                      </div></a
                    >
                  </td>
                  <td class="text-right first:text-left">
                    <a
                      class="block py-4 px-3 sm:px-8"
                      target="_blank"
                      href="/futures-live/indian-railway-fin-corp-l-future-share-price/24Apr25/"
                      ><div class="font-normal leading-5x text-sm text-danger">
                        -₹5.89 (-5.65%)
                      </div></a
                    >
                  </td>
                </tr>
                <tr
                  class="group cursor-pointer bg-gray-light futures-options-hover-state"
                >
                  <td
                    class="text-right first:text-left first:rounded-bl-lg last:rounded-br-lg"
                  >
                    <a
                      class="py-4 flex flex-row items-center gap-1 px-3 sm:px-8"
                      target="_blank"
                      href="/futures-live/indian-railway-fin-corp-l-future-share-price/27Mar25/"
                      ><div
                        class="font-normal leading-5x text-sm text-lighter-black group-hover:text-primary-base"
                      >
                        IRFC FUT 27 MAR 25
                      </div>
                      <div class="hidden group-hover:block">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          class="fill-[#101010] group-hover:fill-[#5A2989]"
                        >
                          <path
                            d="M10.6688 6.27614L4.93109 12.0139L3.98828 11.0711L9.72601 5.33333H4.66883V4H12.0021V11.3333H10.6688V6.27614Z"
                          ></path>
                        </svg></div
                    ></a>
                  </td>
                  <td
                    class="text-right first:text-left first:rounded-bl-lg last:rounded-br-lg"
                  >
                    <a
                      class="block py-4 px-3 sm:px-8"
                      target="_blank"
                      href="/futures-live/indian-railway-fin-corp-l-future-share-price/27Mar25/"
                      ><div
                        class="font-normal leading-5x text-sm text-lighter-black"
                      >
                        ₹104.73
                      </div></a
                    >
                  </td>
                  <td
                    class="text-right first:text-left first:rounded-bl-lg last:rounded-br-lg"
                  >
                    <a
                      class="block py-4 px-3 sm:px-8"
                      target="_blank"
                      href="/futures-live/indian-railway-fin-corp-l-future-share-price/27Mar25/"
                      ><div class="font-normal leading-5x text-sm text-danger">
                        -₹5.40 (-4.9%)
                      </div></a
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <a
            target="_blank"
            href="/option-chain/indian-railway-fin-corp-l/"
            ><div
              class="flex cursor-pointer gap-1 text-sm font-semibold leading-5 text-primary-base"
            >
              View all<img
                alt="expand"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                style="color: transparent"
                src="/next-scrip-assets/purple-down-arrow.svg"
              /></div
          ></a>
        </div>
        <div
          class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
        ></div>
        <div class="py-6 pb-0" id="More" data-section="true">
          <div class="flex w-full items-center justify-between">
            <div
              class="flex gap-1 text-xl font-semibold leading-7 text-lighter-black mb-0"
            >
              <div>More</div>
            </div>
          </div>
          <div class="py-6" id="Similar stocks" data-section="true">
            <div
              class="flex w-full items-center justify-between cursor-pointer"
            >
              <div
                class="mb-4 flex gap-1 text-lighter-black text-base font-semibold leading-6"
              >
                <h2>Stocks Similar to Indian Railway Finance Corp</h2>
              </div>
              <img
                alt="arrow"
                loading="lazy"
                width="24"
                height="24"
                decoding="async"
                data-nimg="1"
                class="mb-4 cursor-pointer text-base font-semibold leading-6"
                style="color: transparent"
                src="/next-scrip-assets/up-arrow.svg"
              />
            </div>
            <div class="flex flex-col py-4">
              <div
                class="no-scrollbar mx-[-16px] flex snap-x snap-mandatory gap-3 overflow-x-scroll sm:mx-0 md:scroll-px-0 md:px-0"
              >
                <a
                  class="pl-4 sm:pl-0"
                  href="/stocks/power-fin-corp-ltd-share-price/INE134E01011/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      Power Finance Corp
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹364.30
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-danger"
                    >
                      -₹13.80 (-3.65%)
                    </p>
                  </div></a
                ><a
                  class=""
                  href="/stocks/gujarat-state-financial-corpor-share-price/INE944A01011/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      GUJARAT STATE FINANCIAL CORPOR
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹17.06
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-green-base"
                    >
                      +₹0.13 (0.77%)
                    </p>
                  </div></a
                ><a
                  class=""
                  href="/stocks/tourism-finance-corp-of-share-price/INE305A01015/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      Tourism Finance Corporation of India
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹146.20
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-green-base"
                    >
                      +₹1.32 (0.91%)
                    </p>
                  </div></a
                ><a
                  class=""
                  href="/stocks/satin-credit-net-ltd-share-price/INE836B01017/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      Satin Credit Net
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹145.94
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-danger"
                    >
                      -₹1.79 (-1.21%)
                    </p>
                  </div></a
                ><a
                  class=""
                  href="/stocks/ifci-ltd-share-price/INE039A01010/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      IFCI
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹41.09
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-danger"
                    >
                      -₹1.50 (-3.52%)
                    </p>
                  </div></a
                ><a
                  class=""
                  href="/stocks/mas-financial-serv-ltd-share-price/INE348L01012/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      MAS Financial
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹233.55
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-danger"
                    >
                      -₹6.00 (-2.5%)
                    </p>
                  </div></a
                ><a
                  class="pr-4 sm:pr-0"
                  href="/stocks/rec-limited-share-price/INE020B01018/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      REC
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹360.30
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-danger"
                    >
                      -₹18.20 (-4.81%)
                    </p>
                  </div></a
                >
              </div>
            </div>
            <div class="ml-auto hidden gap-4 md:flex md:justify-end">
              <div
                class="flex h-8 w-8 items-center justify-center rounded-full border border-gray-dark p-1 cursor-not-allowed opacity-30"
              >
                <img
                  alt="left"
                  fetchpriority="high"
                  width="12"
                  height="12"
                  decoding="async"
                  data-nimg="1"
                  class="rotate-180"
                  src="/next-scrip-assets/forward-arrow.svg"
                  style="color: transparent"
                />
              </div>
              <div
                class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-gray-dark p-1"
              >
                <img
                  alt="right"
                  fetchpriority="high"
                  width="12"
                  height="12"
                  decoding="async"
                  data-nimg="1"
                  src="/next-scrip-assets/forward-arrow.svg"
                  style="color: transparent"
                />
              </div>
            </div>
          </div>
          <div
            class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
          ></div>
          <div class="py-6" id="People also bought" data-section="true">
            <div
              class="flex w-full items-center justify-between cursor-pointer"
            >
              <div
                class="mb-4 flex gap-1 text-lighter-black text-base font-semibold leading-6"
              >
                <h2>Popular Stocks</h2>
              </div>
              <img
                alt="arrow"
                loading="lazy"
                width="24"
                height="24"
                decoding="async"
                data-nimg="1"
                class="mb-4 cursor-pointer text-base font-semibold leading-6"
                style="color: transparent"
                src="/next-scrip-assets/up-arrow.svg"
              />
            </div>
            <div class="flex flex-col py-4">
              <div
                class="no-scrollbar mx-[-16px] flex snap-x snap-mandatory gap-3 overflow-x-scroll sm:mx-0 md:scroll-px-0 md:px-0"
              >
                <a
                  class="pl-4 sm:pl-0"
                  href="/stocks/tata-power-co-ltd-share-price/INE245A01021/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      Tata Power
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹339.20
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-danger"
                    >
                      -₹4.10 (-1.19%)
                    </p>
                  </div></a
                ><a
                  class=""
                  href="/stocks/tata-motors-limited-share-price/INE155A01022/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      Tata Motors
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹620.65
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-danger"
                    >
                      -₹27.90 (-4.3%)
                    </p>
                  </div></a
                ><a
                  class=""
                  href="/stocks/tata-steel-limited-share-price/INE081A01020/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      Tata Steel
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹137.20
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-danger"
                    >
                      -₹1.49 (-1.07%)
                    </p>
                  </div></a
                ><a
                  class=""
                  href="/stocks/suzlon-energy-limited-share-price/INE040H01021/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      Suzlon Energy
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹49.71
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-danger"
                    >
                      -₹2.42 (-4.64%)
                    </p>
                  </div></a
                ><a
                  class=""
                  href="/stocks/yes-bank-limited-share-price/INE528G01035/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      YES Bank
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹16.75
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-danger"
                    >
                      -₹0.61 (-3.51%)
                    </p>
                  </div></a
                ><a
                  class=""
                  href="/stocks/nhpc-ltd-share-price/INE848E01016/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      NHPC
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹72.90
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-danger"
                    >
                      -₹1.41 (-1.9%)
                    </p>
                  </div></a
                ><a
                  class=""
                  href="/stocks/rail-vikas-nigam-limited-share-price/INE415G01027/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      Rail Vikas Nigam
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹332.40
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-danger"
                    >
                      -₹17.65 (-5.04%)
                    </p>
                  </div></a
                ><a
                  class=""
                  href="/stocks/jio-fin-services-ltd-share-price/INE758E01017/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      JIO FIN SERVICES LTD
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹207.61
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-danger"
                    >
                      -₹14.09 (-6.36%)
                    </p>
                  </div></a
                ><a
                  class=""
                  href="/stocks/indian-renewable-energy-share-price/INE202E01016/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      INDIAN RENEWABLE ENERGY
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹156.02
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-danger"
                    >
                      -₹10.49 (-6.3%)
                    </p>
                  </div></a
                ><a
                  class="pr-4 sm:pr-0"
                  href="/stocks/trident-limited-share-price/INE064C01022/"
                  ><div
                    class="h-full w-[148px] cursor-pointer rounded-xl bg-gray-light p-4 text-light-black"
                  >
                    <p
                      class="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 tracking-[-0.09px]"
                    >
                      Trident
                    </p>
                    <p
                      class="mt-2 text-xl font-semibold leading-6 tracking-[-0.7px]"
                    >
                      ₹25.79
                    </p>
                    <p
                      class="text-sm font-medium leading-5 tracking-[-0.09px] text-danger"
                    >
                      -₹0.84 (-3.15%)
                    </p>
                  </div></a
                >
              </div>
            </div>
            <div class="ml-auto hidden gap-4 md:flex md:justify-end">
              <div
                class="flex h-8 w-8 items-center justify-center rounded-full border border-gray-dark p-1 cursor-not-allowed opacity-30"
              >
                <img
                  alt="left"
                  fetchpriority="high"
                  width="12"
                  height="12"
                  decoding="async"
                  data-nimg="1"
                  class="rotate-180"
                  src="/next-scrip-assets/forward-arrow.svg"
                  style="color: transparent"
                />
              </div>
              <div
                class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-gray-dark p-1"
              >
                <img
                  alt="right"
                  fetchpriority="high"
                  width="12"
                  height="12"
                  decoding="async"
                  data-nimg="1"
                  src="/next-scrip-assets/forward-arrow.svg"
                  style="color: transparent"
                />
              </div>
            </div>
          </div>
          <div
            class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
          ></div>
        </div>
        <div class="py-6" id="News" data-section="true">
          <div class="flex w-full items-center justify-between cursor-pointer">
            <div
              class="mb-4 flex gap-1 text-xl font-semibold leading-7 text-lighter-black"
            >
              <h2>Indian Railway Finance Corp News</h2>
            </div>
            <img
              alt="arrow"
              loading="lazy"
              width="24"
              height="24"
              decoding="async"
              data-nimg="1"
              class="mb-4 cursor-pointer"
              style="color: transparent"
              src="/next-scrip-assets/up-arrow.svg"
            />
          </div>
          <div class="flex flex-col py-4">
            <div
              class="no-scrollbar mx-[-16px] flex snap-x snap-mandatory gap-3 overflow-x-scroll sm:mx-0 md:scroll-px-0 md:px-0"
            >
              <a
                target="_blank"
                rel="nofollow"
                class="pl-4 sm:pl-0"
                href="https://www.livemint.com/market/stock-market-news/technical-picks-nagaraj-shetti-of-hdfc-securities-suggests-these-2-stocks-to-buy-or-sell-in-the-nearterm-11740637337006.html"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex gap-2">
                    <img
                      alt="news logo"
                      loading="lazy"
                      width="24"
                      height="24"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://cdn.flipitnews.com/img/broker/Livemint.jpg"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Livemint
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Nagaraj Shetti of HDFC Securities suggests these 2 stocks
                    for near term
                  </p>
                </div></a
              ><a
                target="_blank"
                rel="follow"
                class=""
                href="/news/market-news/stocks/rvnl-irfc-irctc-and-other-railway-stocks-tumble-up-to-7-as-budget-2025-falls-short-of-market-expectations/article-143887/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex gap-2">
                    <img
                      alt="news logo"
                      loading="lazy"
                      width="24"
                      height="24"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    RVNL, IRFC and other railway stocks tumble up to 7% as
                    Budget 2025 falls short of market expectations
                  </p>
                </div></a
              ><a
                target="_blank"
                rel="nofollow"
                class=""
                href="https://www.cnbctv18.com/market/rvnl-irfc-ircon-share-price-railway-psu-stocks-crash-budget-2025-allocation-fall-from-peak-19551460.htm"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex gap-2">
                    <img
                      alt="news logo"
                      loading="lazy"
                      width="24"
                      height="24"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://cdn.flipitnews.com/img/broker/AOJFokpOLjcg4crr7CmgxnBhWqYhCaUXTUO2oedQ.jpg"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      CNBC
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    RVNL, IRFC shares fall another 6%
                  </p>
                </div></a
              ><a
                target="_blank"
                rel="nofollow"
                class=""
                href="https://www.cnbctv18.com/market/rvnl-irfc-ircon-share-price-railway-psu-stocks-crash-budget-2025-allocation-fall-from-peak-19551460.htm"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex gap-2">
                    <img
                      alt="news logo"
                      loading="lazy"
                      width="24"
                      height="24"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://cdn.flipitnews.com/img/broker/zcKzwQ5rCKwfXOrYqo7b0Zm22Vi7cw32KYSKVngR.jpg"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      CNBC Television
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    RVNL, IRFC shares fall another 6%
                  </p>
                </div></a
              ><a
                target="_blank"
                rel="follow"
                class=""
                href="/news/market-news/stocks/weekly-wrap-how-railway-stocks-performed-in-budget-week/article-143756/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex gap-2">
                    <img
                      alt="news logo"
                      loading="lazy"
                      width="24"
                      height="24"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Weekly wrap: How railway stocks performed in Budget week
                  </p>
                </div></a
              ><a
                target="_blank"
                rel="nofollow"
                class=""
                href="https://www.moneycontrol.com/news/business/stocks/railway-stocks-tumble-after-fm-sitharaman-mentions-no-major-reforms-for-the-sector-in-budget-12926861.html"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex gap-2">
                    <img
                      alt="news logo"
                      loading="lazy"
                      width="24"
                      height="24"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://cdn.flipitnews.com/img/broker/Moneycontrol.jpg"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Moneycontrol
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Railway stocks tumble after FM Sitharaman mentions no major
                    reforms
                  </p>
                </div></a
              ><a
                target="_blank"
                rel="follow"
                class=""
                href="/news/market-news/stocks/railtel-rvnl-and-other-railway-stocks-rise-up-to-5-ahead-of-union-budget-2025-check-details/article-143602/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex gap-2">
                    <img
                      alt="news logo"
                      loading="lazy"
                      width="24"
                      height="24"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Railtel, RVNL and other railway PSU stocks rise up to 5%
                    ahead of Union Budget 2025; check details
                  </p>
                </div></a
              ><a
                target="_blank"
                rel="follow"
                class=""
                href="/news/market-news/stocks/irctc-rvnl-irfc-here-s-how-railway-stocks-performed-this-week-ahead-of-union-budget-2025/article-142305/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex gap-2">
                    <img
                      alt="news logo"
                      loading="lazy"
                      width="24"
                      height="24"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    IRCTC, RVNL, IRFC: Here’s how railway stocks performed this
                    week ahead of Union Budget 2025
                  </p>
                </div></a
              ><a
                target="_blank"
                rel="follow"
                class=""
                href="/news/market-news/latest-updates/budget-2025-indian-railways-set-for-big-funding-boost-new-trains-and-infrastructure-upgrades-check-key-stocks-in-focus/article-141741/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex gap-2">
                    <img
                      alt="news logo"
                      loading="lazy"
                      width="24"
                      height="24"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Budget 2025: Indian Railways may get funding boost, new
                    trains, and infrastructure upgrades; check key stocks in
                    focus
                  </p>
                </div></a
              ><a
                target="_blank"
                rel="nofollow"
                class="pr-4 sm:pr-0"
                href="https://economictimes.indiatimes.com/markets/stocks/news/irfc-q3-results-net-profit-gains-2-yoy-to-rs-1630-crore-revenue-flat/articleshow/117393513.cms"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex gap-2">
                    <img
                      alt="news logo"
                      loading="lazy"
                      width="24"
                      height="24"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://cdn.flipitnews.com/img/broker/The Economic Times.jpg"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      ET
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    IRFC Q3 Results: Net profit gains 2% YoY to Rs 1,631 crore,
                    revenue flat
                  </p>
                </div></a
              >
            </div>
          </div>
          <div class="ml-auto hidden gap-4 md:flex md:justify-end">
            <div
              class="flex h-8 w-8 items-center justify-center rounded-full border border-gray-dark p-1 cursor-not-allowed opacity-30"
            >
              <img
                alt="left"
                fetchpriority="high"
                width="12"
                height="12"
                decoding="async"
                data-nimg="1"
                class="rotate-180"
                style="color: transparent"
                src="/next-scrip-assets/forward-arrow.svg"
              />
            </div>
            <div
              class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-gray-dark p-1"
            >
              <img
                alt="right"
                fetchpriority="high"
                width="12"
                height="12"
                decoding="async"
                data-nimg="1"
                style="color: transparent"
                src="/next-scrip-assets/forward-arrow.svg"
              />
            </div>
          </div>
        </div>
        <div
          class="mx-auto my-4 w-full border-b border-gray-accent2 mb-0 mt-0"
        ></div>
        <div class="pb-16">
          <h2
            class="text-primary-text py-6 m-0 text-base font-semibold sm:text-base"
          >
            FAQs on Indian Railway Finance Corp
          </h2>
          <div>
            <div class="mb-4 border-b border-b-gray-accent2 pb-4">
              <div>
                <div class="cursor-pointer">
                  <div
                    class="group flex w-full items-start justify-between px-0 py-2 text-left md:items-center md:leading-10 text-sm font-semibold"
                    data-state="closed"
                  >
                    <h3
                      class="basis-11/12 text-sm font-semibold text-primary-text md:basis-full"
                    >
                      What is the Indian Railway Finance Corp share price today?
                    </h3>
                    <span
                      class="hidden text-lg font-bold group-data-[state=open]:block"
                      ><img
                        alt="chevron-up"
                        loading="lazy"
                        width="20"
                        height="20"
                        decoding="async"
                        data-nimg="1"
                        src="/next-scrip-assets/_next/static/media/chevron-up.b000aa56.svg"
                        style="color: transparent" /></span
                    ><span
                      class="block text-lg font-bold group-data-[state=open]:hidden"
                      ><img
                        alt="chevron-up"
                        loading="lazy"
                        width="20"
                        height="20"
                        decoding="async"
                        data-nimg="1"
                        src="/next-scrip-assets/_next/static/media/ChevronDown.04b13101.svg"
                        style="color: transparent"
                    /></span>
                  </div>
                </div>
                <div
                  class="transition-all duration-300 ease-in-out overflow-hidden font-medium text-sm text-gray-accent3 block"
                  style="max-height: 0px"
                >
                  <div
                    class="pr-4 text-sm font-medium pb-2 pt-4 text-gray-dark leading-4 md:leading-6"
                  >
                    Indian Railway Finance Corp share price is ₹ 112.42 today.
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-4 border-b border-b-gray-accent2 pb-4">
              <div>
                <div class="cursor-pointer">
                  <div
                    class="group flex w-full items-start justify-between px-0 py-2 text-left md:items-center md:leading-10 text-sm font-semibold"
                    data-state="closed"
                  >
                    <h3
                      class="basis-11/12 text-sm font-semibold text-primary-text md:basis-full"
                    >
                      What is today’s high &amp; low share price of Indian
                      Railway Finance Corp?
                    </h3>
                    <span
                      class="hidden text-lg font-bold group-data-[state=open]:block"
                      ><img
                        alt="chevron-up"
                        loading="lazy"
                        width="20"
                        height="20"
                        decoding="async"
                        data-nimg="1"
                        src="/next-scrip-assets/_next/static/media/chevron-up.b000aa56.svg"
                        style="color: transparent" /></span
                    ><span
                      class="block text-lg font-bold group-data-[state=open]:hidden"
                      ><img
                        alt="chevron-up"
                        loading="lazy"
                        width="20"
                        height="20"
                        decoding="async"
                        data-nimg="1"
                        src="/next-scrip-assets/_next/static/media/ChevronDown.04b13101.svg"
                        style="color: transparent"
                    /></span>
                  </div>
                </div>
                <div
                  class="transition-all duration-300 ease-in-out overflow-hidden font-medium text-sm text-gray-accent3 block"
                  style="max-height: 0px"
                >
                  <div
                    class="pr-4 text-sm font-medium pb-2 pt-4 text-gray-dark leading-4 md:leading-6"
                  >
                    Indian Railway Finance Corp share price high: ₹ 119.43 and
                    low: ₹ 111.70
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-4 border-b border-b-gray-accent2 pb-4">
              <div>
                <div class="cursor-pointer">
                  <div
                    class="group flex w-full items-start justify-between px-0 py-2 text-left md:items-center md:leading-10 text-sm font-semibold"
                    data-state="closed"
                  >
                    <h3
                      class="basis-11/12 text-sm font-semibold text-primary-text md:basis-full"
                    >
                      What is the Indian Railway Finance Corp share price high
                      and low in the last 52 weeks on the NSE?
                    </h3>
                    <span
                      class="hidden text-lg font-bold group-data-[state=open]:block"
                      ><img
                        alt="chevron-up"
                        loading="lazy"
                        width="20"
                        height="20"
                        decoding="async"
                        data-nimg="1"
                        src="/next-scrip-assets/_next/static/media/chevron-up.b000aa56.svg"
                        style="color: transparent" /></span
                    ><span
                      class="block text-lg font-bold group-data-[state=open]:hidden"
                      ><img
                        alt="chevron-up"
                        loading="lazy"
                        width="20"
                        height="20"
                        decoding="async"
                        data-nimg="1"
                        src="/next-scrip-assets/_next/static/media/ChevronDown.04b13101.svg"
                        style="color: transparent"
                    /></span>
                  </div>
                </div>
                <div
                  class="transition-all duration-300 ease-in-out overflow-hidden font-medium text-sm text-gray-accent3 block"
                  style="max-height: 0px"
                >
                  <div
                    class="pr-4 text-sm font-medium pb-2 pt-4 text-gray-dark leading-4 md:leading-6"
                  >
                    52 Week share High Price is ₹ 229.00 and Low Price is ₹
                    111.70
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-4 border-b border-b-gray-accent2 pb-4">
              <div>
                <div class="cursor-pointer">
                  <div
                    class="group flex w-full items-start justify-between px-0 py-2 text-left md:items-center md:leading-10 text-sm font-semibold"
                    data-state="closed"
                  >
                    <h3
                      class="basis-11/12 text-sm font-semibold text-primary-text md:basis-full"
                    >
                      What is the Indian Railway Finance Corp Stock Symbol?
                    </h3>
                    <span
                      class="hidden text-lg font-bold group-data-[state=open]:block"
                      ><img
                        alt="chevron-up"
                        loading="lazy"
                        width="20"
                        height="20"
                        decoding="async"
                        data-nimg="1"
                        src="/next-scrip-assets/_next/static/media/chevron-up.b000aa56.svg"
                        style="color: transparent" /></span
                    ><span
                      class="block text-lg font-bold group-data-[state=open]:hidden"
                      ><img
                        alt="chevron-up"
                        loading="lazy"
                        width="20"
                        height="20"
                        decoding="async"
                        data-nimg="1"
                        src="/next-scrip-assets/_next/static/media/ChevronDown.04b13101.svg"
                        style="color: transparent"
                    /></span>
                  </div>
                </div>
                <div
                  class="transition-all duration-300 ease-in-out overflow-hidden font-medium text-sm text-gray-accent3 block"
                  style="max-height: 0px"
                >
                  <div
                    class="pr-4 text-sm font-medium pb-2 pt-4 text-gray-dark leading-4 md:leading-6"
                  >
                    The Indian Railway Finance Corp Stock symbol is IRFC.
                  </div>
                </div>
              </div>
            </div>
            <div class="">
              <div>
                <div class="cursor-pointer">
                  <div
                    class="group flex w-full items-start justify-between px-0 py-2 text-left md:items-center md:leading-10 text-sm font-semibold"
                    data-state="closed"
                  >
                    <h3
                      class="basis-11/12 text-sm font-semibold text-primary-text md:basis-full"
                    >
                      Can I buy Indian Railway Finance Corp shares on Holidays?
                    </h3>
                    <span
                      class="hidden text-lg font-bold group-data-[state=open]:block"
                      ><img
                        alt="chevron-up"
                        loading="lazy"
                        width="20"
                        height="20"
                        decoding="async"
                        data-nimg="1"
                        src="/next-scrip-assets/_next/static/media/chevron-up.b000aa56.svg"
                        style="color: transparent" /></span
                    ><span
                      class="block text-lg font-bold group-data-[state=open]:hidden"
                      ><img
                        alt="chevron-up"
                        loading="lazy"
                        width="20"
                        height="20"
                        decoding="async"
                        data-nimg="1"
                        src="/next-scrip-assets/_next/static/media/ChevronDown.04b13101.svg"
                        style="color: transparent"
                    /></span>
                  </div>
                </div>
                <div
                  class="transition-all duration-300 ease-in-out overflow-hidden font-medium text-sm text-gray-accent3 block"
                  style="max-height: 0px"
                >
                  <div
                    class="pr-4 text-sm font-medium pb-2 pt-4 text-gray-dark leading-4 md:leading-6"
                  >
                    <div>
                      <div class="text-sm text-gray-accent3">
                        No, shares of Indian Railway Finance Corp or any other
                        publicly traded company cannot be bought or sold on
                        holidays when the stock exchanges are closed. You can
                        only buy or sell Indian Railway Finance Corp shares on
                        days when the stock exchanges are open for trading. It's
                        important to check the
                        <a
                          class="text-primary-base"
                          target="_blank"
                          href="/stocks-market/nse-holidays-2024/"
                          >NSE</a
                        >
                        &amp;
                        <a
                          class="text-primary-base"
                          target="_blank"
                          href="/stocks-market/bse-holidays-2024/"
                          >BSE</a
                        >
                        holidays calendar, before placing any trades to avoid
                        any inconvenience.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fixed bottom-[-1px] left-0 z-[13] h-auto w-full translate-y-0 bg-white shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.10)] transition-all duration-500 md:translate-y-full md:hidden rounded-none"
        >
          <div
            class="flex items-center justify-between border-t border-t-gray-300 px-4 py-2"
          >
            <div
              class="duration-[0.5s] ease-[ease-in] flex h-10 w-[132px] items-center gap-2 rounded-[48px] border border-gray-accent4 px-2 py-1.5 transition-all"
            >
              <img
                alt="Trending Data Icon"
                loading="lazy"
                width="24"
                height="24"
                decoding="async"
                data-nimg="1"
                src="/next-scrip-assets/trophy.svg"
                style="color: transparent"
              />
              <div class="flex flex-col gap-1">
                <p
                  class="text-xs font-bold leading-4 tracking-[0.01px] text-light-black"
                >
                  42
                </p>
                <p
                  class="text-[10px] font-medium leading-3 tracking-[0.1px] text-gray-accent3"
                >
                  Uptrend
                </p>
              </div>
            </div>
            <button
              class="cursor-pointer disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark2 disabled:bg-primary-base/50 rounded-full px-11 py-2.5 text-sm font-bold leading-5 tracking-[-0.09px]"
            >
              Start Investing
            </button>
          </div>
        </div>
      </div>
      <div class="sticky mt-16 hidden max-w-[320px] self-start md:block top-36">
        <div class="flex flex-col gap-3">
          <form>
            <div
              class="mb-5 flex flex-col rounded-2xl border border-gray-200 px-4 py-6"
            >
              <div class="flex flex-col items-center justify-center">
                <div class="text-sm font-normal leading-5 text-gray-800">
                  Invest Right, Invest Now
                </div>
                <div
                  class="pt-2 text-center text-2xl font-normal leading-8 tracking-[-0.24px] text-black"
                >
                  Trusted by 1 cr+ Indians for their wealth-building needs
                </div>
                <div
                  class="my-6 rounded-lg border border-gray-300 px-4 py-[13px]"
                >
                  <div class="m-auto flex items-center">
                    <div class="mr-3 min-w-[54px] text-primary-base">
                      <p
                        class="inline-block align-top text-lg font-normal leading-[26px]"
                      >
                        ₹
                      </p>
                      <p
                        class="text--primary-accent relative top-[-3px] inline-block align-top text-[32px] font-semibold leading-[42px]"
                      >
                        0
                      </p>
                    </div>
                    <div class="text-[13px] font-normal not-italic text-black">
                      Account maintenance charges (AMC)
                    </div>
                  </div>
                  <hr class="my-2 h-px w-full bg-gray-300" />
                  <div class="m-auto flex items-center">
                    <div class="mr-3 min-w-[54px] text-primary-base">
                      <p
                        class="inline-block align-top text-lg font-normal leading-[26px]"
                      >
                        ₹
                      </p>
                      <p
                        class="text-brand-light-purple relative top-[-3px] inline-block align-top text-[32px] font-semibold leading-[42px]"
                      >
                        0
                      </p>
                    </div>
                    <div class="text-[13px] font-normal not-italic text-black">
                      Commission on Mutual Funds and IPOs
                    </div>
                  </div>
                  <hr class="my-2 h-px w-full bg-gray-300" />
                  <div class="m-auto flex items-center">
                    <div class="mr-3 min-w-[54px] text-primary-base">
                      <p
                        class="inline-block align-top text-lg font-normal leading-[26px]"
                      >
                        ₹
                      </p>
                      <p
                        class="text-brand-light-purple relative top-[-3px] inline-block align-top text-[32px] font-semibold leading-[42px]"
                      >
                        20
                      </p>
                    </div>
                    <div class="text-[13px] font-normal not-italic text-black">
                      Brokerage of up to ₹20/order on Equity and F&amp;O
                    </div>
                  </div>
                </div>
              </div>
              <div class="relative flex items-center text-base leading-6">
                <div
                  class="absolute left-4 flex items-center text-sm font-semibold leading-5 text-black"
                >
                  <img
                    alt="indian-flag"
                    loading="lazy"
                    width="16"
                    height="12"
                    decoding="async"
                    data-nimg="1"
                    class="mr-1"
                    style="color: transparent"
                    src="/next-scrip-assets/indian-flag.svg"
                  /><span class="font-semibold">+91</span>
                </div>
                <input
                  autocomplete="off"
                  autocorrect="off"
                  type="tel"
                  class="h-[52px] w-full gap-3 rounded-lg border border-black bg-gray-100 px-4 py-2 pl-[68px] outline-none"
                  placeholder="Enter your mobile number"
                  name="phoneInput"
                  value=""
                />
              </div>
              <span class="text-xs text-red-600"></span
              ><button
                class="cursor-pointer px-4 text-sm font-semibold disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark2 disabled:bg-primary-base/50 rounded-lg mt-3 w-full py-3"
                type="submit"
              >
                Open FREE Demat Account Now
              </button>
              <p class="pt-2 text-[10px] font-normal leading-4 text-gray-400">
                By signing up, you agree to receive transaction updates from
                Upstox.
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>
<style scoped>
</style>
